import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { NotFoundikk4a5uq9edp as NotFound } from '../../../../../sdk/errors.mjs';
import {
  Contractor1wog4uk4l8u77 as Contractor,
  Clientuccelyr89ch8 as Client,
  LineItem2rt64afaiyloc as LineItem,
  IncidentMessageComment1adwwkgdgyo0h as IncidentMessageComment,
  Dispute39kejofcwuxch as Dispute,
  DisputeState_Ongoing_getInstance2zn99spsjy3fz as DisputeState_Ongoing_getInstance,
  IncidentMessage1zg9aeg4hgwtu as IncidentMessage,
  ProjectTimerh0tihs6u35t6 as ProjectTimer,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_project15zbqkhtwq5i6 as get_project } from '../../../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  singleOrNullrknfaxokm1sl as singleOrNull,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  last1vo29oleiqj36 as last,
  plus310ted5e4i90h as plus,
  contains2gm06f5aa19ov as contains,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  Creditv1m3yq08fl3i as Credit,
  Companion_getInstance1twm7uvvfawb7 as Companion_getInstance,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__rangeTo_impl_1k0odj1ncwos3p2ntha as MonetaryValue__rangeTo_impl_1k0odj,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
  TimerAction_AllowLockProject_getInstance3xutugx5am7q as TimerAction_AllowLockProject_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  get_textButtonybbt8y3eu5hx as get_textButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance,
  SecondaryButtonSemantic_getInstance1ksz6yxlolvnl as SecondaryButtonSemantic_getInstance,
} from '../../../../theming/buttons.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atTopStart2sqdmdfleu6ji as get_atTopStart,
  get_atEnd1cw5d2zgug26 as get_atEnd,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
  get_atTopCenter1v6irntzl0tu6 as get_atTopCenter,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  applyReactiveActionFormatting11beyf0tv05i4 as applyReactiveActionFormatting,
  ButtonActionqmmxsu493eh2 as ButtonAction,
  button2ojurxuym14mn as button,
} from '../../../../../utils/ButtonAction.mjs';
import {
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
} from '../../../nav/crowpay.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { markAsReadUpdateOnRemovek70bbxx94h7h as markAsReadUpdateOnRemove } from '../../../../../extensions/HasReadBy.ext.mjs';
import {
  setOf1u3mizs95ngxo as setOf,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { get_incidentys14r5mjqskx as get_incident } from '../../../../../../../../crowpay-shared/com/crowpay/CreditFields.mjs';
import {
  Accept3c5lxev9vmal1 as Accept,
  ContractorDisputefe9zenbw9zpq as ContractorDispute,
  NotResponsible5sod6b685ij0 as NotResponsible,
  Appealxiso3o25clbz as Appeal,
  RequestSiteVisit2qqplegjmdj5x as RequestSiteVisit,
  RemedyHandled1fest6c8tpi44 as RemedyHandled,
  Remedy2jczhqm350rbv as Remedy,
  Credit3h7kqwetoaiq0 as Credit_0,
  Handled19mgago2u0m72 as Handled,
  ClientResponsexqxw1r0z235j as ClientResponse,
  FileIncident88pwqv67k7mz as FileIncident,
  DisputeResolution3thfkwxak0ppb as DisputeResolution,
  get_entries1br0wi3ybq930 as get_entries,
  MoreInfo_instancelndi8wb3mxe1 as MoreInfo_instance,
  Appeal_instance35tazwmyjzfwk as Appeal_instance,
  NotResponsible_instance227dyeoudt4p as NotResponsible_instance,
  ClientConcern1skfmbxl86a3t as ClientConcern,
  ClientConcern_Other_getInstancezoo09lwnn20e as ClientConcern_Other_getInstance,
  MoreInfo24u6wgs2qje82 as MoreInfo,
} from '../../../../../../../../crowpay-shared/com/crowpay/incidentResponse/IncidentResponseType.mjs';
import { Triple1vhi3d0dgpnjb as Triple } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  get_incident3rzbe1tjdx6x3 as get_incident_0,
  get_state1140xg7i4ysgd as get_state,
} from '../../../../../../../../crowpay-shared/com/crowpay/DisputeFields.mjs';
import { andvtrcuje7baox as and } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import {
  awaitSuspendingfmims6z9kmaq as awaitSuspending,
  zeroToNull11q39tqjxlqyg as zeroToNull,
  lensFilter5xvs6ea8thrl as lensFilter,
  shownDefaultFalse3hpz4awymyomc as shownDefaultFalse,
} from '../../../../../utils/utils.mjs';
import { delayolwo40i9ucjz as delay } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { requestFiles2wr6y980phloh as requestFiles } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ExternalServices.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  LocalFileyitm5ua4ch17 as LocalFile,
  FileDataw8niis0ucpno as FileData,
  resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments,
} from '../../../files/attachmentFilePreview.mjs';
import {
  Signal1973xs1vkmdcb as Signal,
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  _Constant___get_value__impl__gl47rj3u5ywr3ls9g1y as _Constant___get_value__impl__gl47rj,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  asyncz02dsa2nb2zt as async,
  launch1c91vkjzdi9sd as launch,
} from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { awaitAll3u8r91uegk3sa as awaitAll } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Await.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance_0 } from '../../../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { serializableajawjsrnxxet as serializable } from '../../../../../../../../crowpay-shared/com/crowpay/incidentResponse/serialization.mjs';
import { PlainTextException3c81a0qh9m2e2 as PlainTextException } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import {
  Dimensions32ju1l7z4mh as Dimension,
  divkhq3vjih9fcw as div,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  WordBreak_Normal_getInstance29i995kznehpg as WordBreak_Normal_getInstance,
  WordBreak_BreakAll_getInstance289x8dja79rdq as WordBreak_BreakAll_getInstance,
  timesx4ey3un7ihw1 as times,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  space2ppi73m2qk1br as space,
  Indent_Section_getInstance2f8fy630t595n as Indent_Section_getInstance,
  indented3383b46h9g40w as indented,
} from '../../../space.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_padded3m3frjnjujncx as get_padded,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance,
  ActionImportance_Critical_getInstance3s0xptbpomhhd as ActionImportance_Critical_getInstance,
} from '../../../../screens/common/ProjectView.mjs';
import {
  actionIcon360epyywhabwj as actionIcon,
  escalationIconmtio0lqe8r8o as escalationIcon,
  infoBubblebw7xb14ivkdr as infoBubble,
} from '../../../iconShortcuts.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
  body3i5t0n7zprpqb as body,
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  smallBody2trfy14zwtona as smallBody,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  title1nssp3ryhwuqj as title,
  TitleSemantic_getInstance11rbkzaor5oxz as TitleSemantic_getInstance,
} from '../../../../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Companion_instance1i4n4o7mef2za as Companion_instance_0 } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
import { get_default1l68fybpthpme as get_default } from '../../../../../../../../lightning-server-shared/com/lightningkite/DefaultClock.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import {
  renderBanners1vh1dpq8pq90j as renderBanners,
  banners2ndq1wx79ibxx as banners,
  renderBannersqm0ix48feq51 as renderBanners_0,
  renderBanners2vok7sjtj8k1c as renderBanners_1,
} from '../../../../../utils/Banner.mjs';
import { get_outlinedfhcs63de0vzu as get_outlined } from '../../../../theming/appTheme.mjs';
import { leftExpandButton23soimuuf6gel as leftExpandButton } from '../../../expansion.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Checkbox2he0oy51inwu6 as Checkbox } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Checkbox.commonHtml.mjs';
import {
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  SubtextSemantic_getInstance3oi0npjp97gok as SubtextSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import {
  assertNotNull37l8a72xnu5i6 as assertNotNull,
  assertReactive30c64mz7ckt8m as assertReactive,
  assert1ckwbdkg35i20 as assert,
} from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../../theming/colorManagement.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  Companion_getInstance3qu5ydsg8audm as Companion_getInstance_1,
  toLocalDateTime3u4c8ydzr4ubp as toLocalDateTime,
  toInstant2q17i3aluy6ks as toInstant,
} from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { atTime2v4vw3esgoteo as atTime } from '../../../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  validategsg6go7eyi9d as validate,
  validatecngbak7otryq as validate_0,
  validateReactive1mjr7u7b9jd4s as validateReactive,
} from '../../../../../utils/validation.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { MonetaryValueInput2lk8s753hzo22 as MonetaryValueInput } from '../../../MonetaryValueInput.mjs';
import {
  FormMessage_getInstance34lpbvoeaecrx as FormMessage_getInstance,
  IssueButton_getInstance2eudvtxrfqyy3 as IssueButton_getInstance,
  DisputeButton_getInstance2kmp95ogq1c02 as DisputeButton_getInstance,
  NotReadyButton_getInstance12ctldyuk6wtt as NotReadyButton_getInstance,
  ReportIncidentButton_getInstance34farqsakvpxm as ReportIncidentButton_getInstance,
} from '../../../../theming/formThemes.mjs';
import { displayState2k8glkzyt1ny6 as displayState } from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { IncidentStateSemanticqw5umh5a9l7i as IncidentStateSemantic } from '../../../../theming/states.mjs';
import { isWhitespace25occ8z1ed1s9 as isWhitespace } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { inlineLabel3artc1yn03kdr as inlineLabel } from '../../../keyValue.mjs';
import { renderFiles2vz7gmubfqcvp as renderFiles } from '../../../files/renderFiles.mjs';
import { label287uhiq3m9m4z as label2 } from '../../../label2.mjs';
import { MutableRememberyv35kz5kmml7 as MutableRemember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_2 } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../../../theming/sections.mjs';
import { TextArea6va0jt1dj0tc as TextArea } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextArea.commonHtml.mjs';
import { errorTextv58wi1t0me7u as errorText } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog,
  confirmationDialog1lynowl7yd4cd as confirmationDialog,
} from '../../../../dialogs/GenericConfirmationDialog.mjs';
import {
  IncidentState_Issue_getInstance1n9bsrstuulg4 as IncidentState_Issue_getInstance,
  IncidentState_Disputed_getInstance1vczt2g7fznyr as IncidentState_Disputed_getInstance,
  EscalationLevel_Disputed_getInstance3pwh4crkd38ie as EscalationLevel_Disputed_getInstance,
  IncidentState_IssueFiled_getInstance1pq0p85oj3ba4 as IncidentState_IssueFiled_getInstance,
  EscalationLevel_Issue_getInstancea8pbpo27up2o as EscalationLevel_Issue_getInstance,
  IncidentState_Settled_getInstance1hrwzjvkv7ot8 as IncidentState_Settled_getInstance,
  IncidentState_Resolved_getInstance22hwduixidcb1 as IncidentState_Resolved_getInstance,
  IncidentState_Filed_getInstanceg9puzn4wq1pv as IncidentState_Filed_getInstance,
} from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { fileCarousely0kamh1gns47 as fileCarousel } from '../../../files/fileManager.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import {
  set_value1vvx5pkb20ebv as set_value,
  interceptWrite2xi6g5kl52xuu as interceptWrite,
} from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { confirmLockProject3pubn8irheo5y as confirmLockProject } from '../../../../dialogs/ConfirmLockProjectDialog.mjs';
import { IncidentRequestSignOffDialog16d4wye5a2av3 as IncidentRequestSignOffDialog } from '../../../../dialogs/RequestSignOffDialog.mjs';
import { TextInputDialog3qrlwab43tewg as TextInputDialog } from '../../../../dialogs/TextInputDialog.mjs';
import {
  get_incidenti9ia7anmnpwp as get_incident_1,
  get_created200bf4xepfbhm as get_created,
} from '../../../../../../../../crowpay-shared/com/crowpay/IncidentMessageCommentFields.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { IncidentFlowPermissions44pkdokiuf55 as IncidentFlowPermissions } from '../../../../../../../../crowpay-shared/com/crowpay/incidentResponse/IncidentFlowPermissions.mjs';
import { IssueNode2x8c6ia7dmfdz as IssueNode } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/IssueNode.mjs';
import { asReversed308kw52j6ls1u as asReversed } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ReversedViews.mjs';
import {
  validated3dw9xce8adqbh as validated,
  validatedmmpm5lnzq3lm as validated_0,
} from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { ReactiveMutableList2gg4x024enrbf as ReactiveMutableList } from '../../../../../../../../reactive/com/lightningkite/reactive/core/ReactiveMutableList.mjs';
import { setOf45ia9pnfhe90 as setOf_0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { running1fetq8eynjgzm as running } from '../../../../../../../../crowpay-shared/com/crowpay/conditions.mjs';
import {
  get_incident1vs82es68w39g as get_incident_2,
  get_action1la6do8qxhniz as get_action,
} from '../../../../../../../../crowpay-shared/com/crowpay/ProjectTimerFields.mjs';
import { ContractorProject2o386x7rid4t as ContractorProject } from '../../../../screens/contractor/ContractorProject.mjs';
import { ClientProject3d3kef0q1hn13 as ClientProject } from '../../../../screens/client/ClientProject.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import {
  render1ekxzgt3v21h2 as render,
  DialogOrPageiidrs19hacf7 as DialogOrPage,
  HasFallback3lthr8mgiugg2 as HasFallback,
} from '../../../../screens/common/DialogWithDialog.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_createDialog__bkuuho($this, project, incident, messages, lens, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = session.lfv_1.geo(project.x7a_1);
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().pfx(getKClass(Contractor()), null);
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var contractor = tmp_1;
  var tmp1_elvis_lhs = project.a7b_1;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    throw IllegalStateException().o4('Project has no client');
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = session.kfv_1.geo(tmp_2);
  var tmp_3 = await_0(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp2_elvis_lhs = tmp_3;
  var tmp_4;
  if (tmp2_elvis_lhs == null) {
    throw NotFound().pfx(getKClass(Client()), null);
  } else {
    tmp_4 = tmp2_elvis_lhs;
  }
  var client = tmp_4;
  // Inline function 'com.lightningkite.lightningdb.Query' call
  var limit = 2147483647;
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_5 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
  var tmp$ret$4 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$4);
  var tmp$ret$6 = eq(get_project(it), project.v7a_1);
  var tmp$ret$7 = new (Query())(tmp$ret$6, orderBy, 0, limit);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = session.ofv_1.heo(tmp$ret$7);
  var tmp_6 = await_0(this_3, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  var items = tmp_6;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = messages.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.v67_1.equals(incident == null ? null : incident.b63_1)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_7 = IncidentReportForm$Companion$createDialog$lambda;
  var tmp$ret$12 = new (sam$kotlin_Comparator$0())(tmp_7);
  var tmp_8 = sortedWith(destination, tmp$ret$12);
  var tmp_9;
  switch (lens.b4_1) {
    case 0:
      tmp_9 = false;
      break;
    case 1:
      tmp_9 = true;
      break;
    case 2:
      tmp_9 = true;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var tmp_10 = tmp_9;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = session.rfw_1;
  var tmp_11 = await_0(this_4, $completion);
  if (tmp_11 === get_COROUTINE_SUSPENDED())
    tmp_11 = yield tmp_11;
  var tmp4_safe_receiver = tmp_11.k88_1;
  var tmp_12 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.h8c_1;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().w();
  var _iterator__ex2g4s_0 = items.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    if (element_0.y91()) {
      destination_0.v(element_0);
    }
  }
  // Inline function 'com.crowpay.extensions.sumMoney' call
  var sum = Companion_instance.r91(0n);
  var _iterator__ex2g4s_1 = destination_0.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_1 = _iterator__ex2g4s_1.o1();
    var tmp_13 = sum;
    var tmp$ret$18 = element_1.q91();
    sum = MonetaryValue__plus_impl_c1ylt(tmp_13, tmp$ret$18);
  }
  var tmp$ret$19 = sum;
  return new (IncidentReportForm())(project, incident, tmp_8, client, contractor, tmp_10, tmp_12, tmp$ret$19);
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.sgp_1 = function_0;
      }
      wi(a, b) {
        return this.sgp_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.sgp_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function IncidentReportForm$Companion$createDialog$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.c68_1;
  var tmp$ret$1 = b.c68_1;
  return compareValues(tmp, tmp$ret$1);
}
function actionBar($this, _this__u8e3s4, action) {
  var tmp;
  if (get_viewIsWide(_this__u8e3s4)) {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.gbb(p, view);
    view.zbm(false);
    view.bb9(get_AppDimensions().kg2_1);
    view.lbb(view.kbb(get_centered(view), get_tertiaryButton(view)), attachmentButton($this.wgp_1, view));
    var tmp_0 = get_expanding(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Space())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view.hbb(p_0, view_0);
    view.lbb(tmp_0, view_0);
    view.lbb(get_centered(view), actionBar$goBackButton(view));
    var tmp_1 = get_centered(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (Button())(view.pc());
    var tmp0_elvis_lhs_1 = view.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.gbb(p_1, view_1);
    applyReactiveActionFormatting(view_1, action);
    view.hbb(p_1, view_1);
    view.lbb(tmp_1, view_1);
    _this__u8e3s4.hbb(p, view);
    tmp = view;
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs_2 = _this__u8e3s4.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? _this__u8e3s4 : tmp0_elvis_lhs_2;
    _this__u8e3s4.gbb(p_2, view_2);
    view_2.zbm(true);
    view_2.bb9(get_AppDimensions().kg2_1);
    view_2.lbb(get_tertiaryButton(view_2), attachmentButton($this.wgp_1, view_2));
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Space())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.gbb(p_3, view_3);
    view_2.hbb(p_3, view_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (RowOrCol())(view_2.pc());
    var tmp0_elvis_lhs_4 = view_2.ebb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
    view_2.gbb(p_4, view_4);
    view_4.zbm(false);
    view_4.lbb(view_4.kbb(get_centered(view_4), get_expanding(view_4)), actionBar$goBackButton(view_4));
    var tmp_2 = view_4.kbb(get_centered(view_4), get_expanding(view_4));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (Button())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.ebb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.gbb(p_5, view_5);
    applyReactiveActionFormatting(view_5, action, false);
    view_4.hbb(p_5, view_5);
    view_4.lbb(tmp_2, view_5);
    view_2.hbb(p_4, view_4);
    _this__u8e3s4.hbb(p_2, view_2);
    tmp = view_2;
  }
  return tmp;
}
function actionBar$goBackButton(_this__u8e3s4) {
  var tmp = get_textButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  specCenteredText(view, 'Go Back');
  onClick(view, VOID, VOID, IncidentReportForm$ResponseForm$actionBar$goBackButton$slambda_0());
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
var IncidentReportForm$ResponseForm$render$slambdaClass;
function IncidentReportForm$ResponseForm$render$slambda() {
  if (IncidentReportForm$ResponseForm$render$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$ResponseForm$render$slambdaClass = $;
  }
  return IncidentReportForm$ResponseForm$render$slambdaClass;
}
function IncidentReportForm$ResponseForm$render$slambda_0() {
  var i = new (IncidentReportForm$ResponseForm$render$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function IncidentReportForm$ResponseForm$render$lambda(it) {
  return !(it.dg1_1 == null);
}
var IncidentReportForm$ResponseForm$actionBar$goBackButton$slambdaClass;
function IncidentReportForm$ResponseForm$actionBar$goBackButton$slambda() {
  if (IncidentReportForm$ResponseForm$actionBar$goBackButton$slambdaClass === VOID) {
    class $ {
      uao($completion) {
        get_dialogStack().pgd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$ResponseForm$actionBar$goBackButton$slambdaClass = $;
  }
  return IncidentReportForm$ResponseForm$actionBar$goBackButton$slambdaClass;
}
function IncidentReportForm$ResponseForm$actionBar$goBackButton$slambda_0() {
  var i = new (IncidentReportForm$ResponseForm$actionBar$goBackButton$slambda())();
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = markAsReadUpdateOnRemove(session.jfw_1, $this.xgp_1, $this.ygp_1.egn_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ygp_1.kgn_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = markAsReadUpdateOnRemove(session.kfw_1, $this.xgp_1, tmp$ret$1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  if (!($this.ygp_1.dgn_1 == null)) {
    var tmp_3 = setOf($this.ygp_1.cgn_1);
    // Inline function 'com.lightningkite.lightningdb.condition' call
    // Inline function 'com.lightningkite.lightningdb.path' call
    // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
    var tmp_4 = serializerOrContextual(createKType(getKClass(Credit()), arrayOf([]), false));
    var tmp$ret$2 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
    // Inline function 'kotlin.let' call
    var it = new (DataClassPathSelf())(tmp$ret$2);
    var tmp$ret$6 = eq(get_incident(it), $this.ygp_1.dgn_1.b63_1);
    var tmp_5 = session.rfv_1.jfu(tmp_3, tmp$ret$6, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp3_incidentMessage = $this.zgp_1.u67_1;
  var tmp4_project = $this.agq_1.cgn_1.v7a_1;
  var tmp0_safe_receiver = $this.agq_1.dgn_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b63_1;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var tmp5_incident = tmp_0;
  var tmp6_sender = session.gfv_1;
  var tmp2_elvis_lhs = $this.bgq_1.f2();
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  var tmp7_message = tmp_1;
  var tmp8_clientMessage = $this.agq_1.hgn_1;
  var tmp_2 = session.kfw_1.oft(new (IncidentMessageComment())(VOID, tmp3_incidentMessage, tmp4_project, tmp5_incident, tmp6_sender, VOID, tmp8_clientMessage, tmp7_message), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  $this.bgq_1.oam(null);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, it, $completion) {
  if (it) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var session = tmp;
    $this.cgq_1.pgn_1.oam(new (Accept())($this.dgq_1, session.wfw()));
    var tmp_0 = $this.cgq_1.fgq($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    closeForm($this.cgq_1, $this.egq_1);
  }
  return Unit_instance;
}
function invoke$result(_this__u8e3s4, this$0) {
  return (new (Accept())(_this__u8e3s4, Companion_getInstance().f54_1)).s9e(this$0.mgn_1.p9d_1);
}
function invoke$getText(this$0, proposal) {
  var tmp;
  if (proposal instanceof Handled()) {
    tmp = new (Triple())('Accept Handled?', "This accepts the contractor's response that the concern has been addressed. The incident will be marked as " + invoke$result(proposal, this$0).y9c_1 + '.', 'Accept Handled');
  } else {
    if (proposal instanceof Credit_0()) {
      tmp = new (Triple())('Accept Credit?', "This accepts the contractor's " + MonetaryValue__toString_impl_xslc77(proposal.k9f_1) + ' credit offer. The credit will be applied to your project ledger and the incident will be marked as ' + invoke$result(proposal, this$0).y9c_1 + '.', 'Accept Credit');
    } else {
      if (proposal instanceof Remedy()) {
        tmp = new (Triple())('Accept Remedy Plan?', "This accepts the contractor's remedy plan. Once the work is complete, the contractor will request sign-off for your review. The incident will be marked as " + invoke$result(new (RemedyHandled())(proposal), this$0).y9c_1 + ' after you approve the remedy work.', 'Accept Remedy');
      } else {
        if (proposal instanceof RemedyHandled()) {
          var tmp_0;
          var tmp_1 = proposal.a9f_1.m9f_1;
          if (!((tmp_1 == null ? null : new (MonetaryValue())(tmp_1)) == null)) {
            var tmp1_elvis_lhs = proposal.a9f_1.m9f_1;
            var tmp_2;
            var tmp_3 = tmp1_elvis_lhs;
            if ((tmp_3 == null ? null : new (MonetaryValue())(tmp_3)) == null) {
              tmp_2 = Companion_instance.r91(0n);
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }
            tmp_0 = 'This will apply ' + MonetaryValue__toString_impl_xslc77(tmp_2) + ' of credit to the project and resolve the incident';
          } else {
            tmp_0 = 'This will resolve the incident';
          }
          tmp = new (Triple())('Accept Remedy Handled?', tmp_0, 'Accept Handled');
        } else {
          if (proposal instanceof RequestSiteVisit()) {
            tmp = new (Triple())('Confirm Visit?', 'This confirms the on-site meeting request. Coordinate directly with the contractor to schedule the visit.', 'Confirm Visit');
          } else {
            if (proposal instanceof Appeal()) {
              tmp = new (Triple())('Accept Appeal?', 'This will mark the incident as ' + invoke$result(proposal, this$0).y9c_1, 'Accept Appeal');
            } else {
              if (proposal instanceof NotResponsible()) {
                tmp = new (Triple())('Accept No Fault?', "This accepts the contractor's position that they are not responsible for this incident. The incident will be marked as " + invoke$result(proposal, this$0).y9c_1 + '.', 'Accept No Fault');
              } else {
                if (proposal instanceof ContractorDispute()) {
                  tmp = invoke$getText(this$0, proposal.d9f_1);
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function IncidentReportForm$acceptAction$slambda$lambda($this$GenericConfirmationDialog) {
  get_dialogStack().pgd();
  return Unit_instance;
}
var IncidentReportForm$acceptAction$slambda$slambdaClass;
function IncidentReportForm$acceptAction$slambda$slambda() {
  if (IncidentReportForm$acceptAction$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $proposal, $this_acceptAction) {
        this.cgq_1 = this$0;
        this.dgq_1 = $proposal;
        this.egq_1 = $this_acceptAction;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$acceptAction$slambda$slambdaClass = $;
  }
  return IncidentReportForm$acceptAction$slambda$slambdaClass;
}
function IncidentReportForm$acceptAction$slambda$slambda_0(this$0, $proposal, $this_acceptAction) {
  var i = new (IncidentReportForm$acceptAction$slambda$slambda())(this$0, $proposal, $this_acceptAction);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, it, $completion) {
  if (it) {
    var tmp = $this.ggq_1.fgq($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    closeForm($this.ggq_1, $this.hgq_1);
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = $this.igq_1.fgq($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closeForm($this.igq_1, $this.jgq_1);
  return Unit_instance;
}
var IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass;
function IncidentReportForm$primaryResponseAction$lambda$slambda$slambda() {
  if (IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.igq_1 = this$0;
        this.jgq_1 = $this_primaryResponseAction;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass = $;
  }
  return IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass;
}
function IncidentReportForm$primaryResponseAction$lambda$slambda$slambda_0(this$0, $this_primaryResponseAction) {
  var i = new (IncidentReportForm$primaryResponseAction$lambda$slambda$slambda())(this$0, $this_primaryResponseAction);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  var tmp = $this.kgq_1.fgq($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closeForm($this.kgq_1, $this.lgq_1);
  return Unit_instance;
}
var IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass_0;
function IncidentReportForm$primaryResponseAction$lambda$slambda$slambda_1() {
  if (IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.kgq_1 = this$0;
        this.lgq_1 = $this_primaryResponseAction;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass_0 = $;
  }
  return IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass_0;
}
function IncidentReportForm$primaryResponseAction$lambda$slambda$slambda_2(this$0, $this_primaryResponseAction) {
  var i = new (IncidentReportForm$primaryResponseAction$lambda$slambda$slambda_1())(this$0, $this_primaryResponseAction);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, it, $completion) {
  if (it) {
    var tmp = $this.mgq_1.fgq($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    closeForm($this.mgq_1, $this.ngq_1);
  }
  return Unit_instance;
}
function IncidentReportForm$primaryResponseAction$lambda$slambda$lambda($this$GenericConfirmationDialog) {
  get_dialogStack().pgd();
  return Unit_instance;
}
var IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass_1;
function IncidentReportForm$primaryResponseAction$lambda$slambda$slambda_3() {
  if (IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.mgq_1 = this$0;
        this.ngq_1 = $this_primaryResponseAction;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass_1 = $;
  }
  return IncidentReportForm$primaryResponseAction$lambda$slambda$slambdaClass_1;
}
function IncidentReportForm$primaryResponseAction$lambda$slambda$slambda_4(this$0, $this_primaryResponseAction) {
  var i = new (IncidentReportForm$primaryResponseAction$lambda$slambda$slambda_3())(this$0, $this_primaryResponseAction);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  // Inline function 'com.lightningkite.lightningdb.Query' call
  // Inline function 'kotlin.collections.listOf' call
  var orderBy = emptyList();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(Dispute()), arrayOf([]), false));
  var tmp$ret$2 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$2);
  var tmp_1 = get_incident_0(it);
  var tmp0_safe_receiver = $this.ogq_1.dgn_1;
  var tmp$ret$4 = and(eq(tmp_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b63_1), eq(get_state(it), DisputeState_Ongoing_getInstance()));
  var tmp$ret$5 = new (Query())(tmp$ret$4, orderBy, 0, 1);
  var tmp_2 = awaitSuspending(session.hfw_1.heo(tmp$ret$5), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp0_elvis_lhs = singleOrNull(tmp_2);
  var tmp_3;
  if (tmp0_elvis_lhs == null) {
    throw NotFound().pfx(getKClass(Dispute()), null);
  } else {
    tmp_3 = tmp0_elvis_lhs;
  }
  var dispute = tmp_3;
  var tmp_4 = session.vfw().tff_1.ufj(dispute.i5w_1, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = delay(50n, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  closeForm($this.ogq_1, $this.pgq_1);
  return Unit_instance;
}
var IncidentReportForm$lockProjectAction$slambda$slambdaClass;
function IncidentReportForm$lockProjectAction$slambda$slambda() {
  if (IncidentReportForm$lockProjectAction$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_lockProjectAction) {
        this.ogq_1 = this$0;
        this.pgq_1 = $this_lockProjectAction;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$lockProjectAction$slambda$slambdaClass = $;
  }
  return IncidentReportForm$lockProjectAction$slambda$slambdaClass;
}
function IncidentReportForm$lockProjectAction$slambda$slambda_0(this$0, $this_lockProjectAction) {
  var i = new (IncidentReportForm$lockProjectAction$slambda$slambda())(this$0, $this_lockProjectAction);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_7($this, msg, $completion) {
  if (msg == null) {
    get_dialogStack().pgd();
    return Unit_instance;
  }
  $this.qgq_1.pgn_1.oam(new (ClientResponse())(VOID, true));
  $this.qgq_1.ugn_1.oam(msg);
  var tmp = $this.qgq_1.fgq($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  closeForm($this.qgq_1, $this.rgq_1);
  return Unit_instance;
}
var IncidentReportForm$actionBar$slambda$slambdaClass;
function IncidentReportForm$actionBar$slambda$slambda() {
  if (IncidentReportForm$actionBar$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_actionBar) {
        this.qgq_1 = this$0;
        this.rgq_1 = $this_actionBar;
      }
      sgq(msg, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, msg), $completion);
      }
      s2(p1, $completion) {
        return this.sgq((p1 == null ? true : typeof p1 === 'string') ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$actionBar$slambda$slambdaClass = $;
  }
  return IncidentReportForm$actionBar$slambda$slambdaClass;
}
function IncidentReportForm$actionBar$slambda$slambda_0(this$0, $this_actionBar) {
  var i = new (IncidentReportForm$actionBar$slambda$slambda())(this$0, $this_actionBar);
  var l = (msg, $completion) => i.sgq(msg, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_8($this, $this$async, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.tgq_1.zgb(LiveApi2$Api2IncidentLive$uploadFileForRequest$ref_0(tmp$ret$0.vfw().afg_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var LiveApi2$Api2IncidentLive$uploadFileForRequest$refClass;
function LiveApi2$Api2IncidentLive$uploadFileForRequest$ref() {
  if (LiveApi2$Api2IncidentLive$uploadFileForRequest$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.ugq_1 = p0;
      }
      uao($completion) {
        return this.ugq_1.lfi($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    LiveApi2$Api2IncidentLive$uploadFileForRequest$refClass = $;
  }
  return LiveApi2$Api2IncidentLive$uploadFileForRequest$refClass;
}
function LiveApi2$Api2IncidentLive$uploadFileForRequest$ref_0(p0) {
  var i = new (LiveApi2$Api2IncidentLive$uploadFileForRequest$ref())(p0);
  var l = ($completion) => i.uao($completion);
  l.callableName = 'uploadFileForRequest';
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_9($this, $completion) {
  var tmp = requestFiles($this.vgq_1.pc(), VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = tmp;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var preview = new (LocalFile())(item);
    $this.wgq_1.vgn_1.nam(new (FileData())(VOID, Signal().hak(''), preview, preview));
    var tmp$ret$0 = async($this.vgq_1, VOID, VOID, IncidentReportForm$attachmentButton$slambda$slambda_0(preview));
    destination.v(tmp$ret$0);
  }
  var tmp_0 = awaitAll(destination, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var IncidentReportForm$attachmentButton$slambda$slambdaClass;
function IncidentReportForm$attachmentButton$slambda$slambda() {
  if (IncidentReportForm$attachmentButton$slambda$slambdaClass === VOID) {
    class $ {
      constructor($preview) {
        this.tgq_1 = $preview;
      }
      yah($this$async, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, $this$async), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$attachmentButton$slambda$slambdaClass = $;
  }
  return IncidentReportForm$attachmentButton$slambda$slambdaClass;
}
function IncidentReportForm$attachmentButton$slambda$slambda_0($preview) {
  var i = new (IncidentReportForm$attachmentButton$slambda$slambda())($preview);
  var l = ($this$async, $completion) => i.yah($this$async, $completion);
  l.$arity = 1;
  return l;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      xgq(project, incident, messages, lens, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_createDialog__bkuuho.bind(VOID, this, project, incident, messages, lens), $completion);
      }
    }
    initMetadataForCompanion($, VOID, VOID, [4]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_1;
function Companion_getInstance_3() {
  return Companion_instance_1;
}
function *_generator_sendResponse__y29akh($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.vfw().bfg_1;
  var tmp0_safe_receiver = $this.dgn_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b63_1;
  var tmp_1 = tmp1_elvis_lhs == null ? Companion_getInstance_0().k2p() : tmp1_elvis_lhs;
  var tmp_2;
  if (!$this.hgn_1 && $this.sgn_1.f2()) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.pgn_1;
    var tmp_3 = await_1(this_1, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp_4 = tmp_3;
    var tmp2_elvis_lhs = (!(tmp_4 == null) ? isInterface(tmp_4, DisputeResolution()) : false) ? tmp_4 : null;
    var tmp_5;
    if (tmp2_elvis_lhs == null) {
      throw PlainTextException().lcw('Selected response ' + toString($this.pgn_1.f2()) + " is not a dispute resolution. This shouldn't happen, please report this.");
    } else {
      tmp_5 = tmp2_elvis_lhs;
    }
    tmp_2 = serializable(new (ContractorDispute())(tmp_5));
  } else {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this.pgn_1;
    var tmp_6 = await_1(this_2, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var r = tmp_6;
    var tmp_7;
    if (r == null) {
      return Unit_instance;
    } else {
      if (r instanceof Accept()) {
        tmp_7 = r.r9f(VOID, session.wfw());
      } else {
        if (r instanceof FileIncident()) {
          tmp_7 = r.i9f(VOID, $this.rgn_1.f2());
        } else {
          if (r instanceof ClientResponse()) {
            tmp_7 = r.j9f($this.sgn_1.f2(), $this.ngn_1.f2());
          } else {
            if (r instanceof Credit_0()) {
              // Inline function 'com.lightningkite.reactive.context.invoke' call
              var this_3 = $this.wgn_1;
              var tmp_8 = await_1(this_3, $completion);
              if (tmp_8 === get_COROUTINE_SUSPENDED())
                tmp_8 = yield tmp_8;
              var tmp_9 = tmp_8;
              var tmp3_elvis_lhs = tmp_9 == null ? null : tmp_9.y5r_1;
              var tmp_10;
              var tmp_11 = tmp3_elvis_lhs;
              if ((tmp_11 == null ? null : new (MonetaryValue())(tmp_11)) == null) {
                return Unit_instance;
              } else {
                tmp_10 = tmp3_elvis_lhs;
              }
              tmp_7 = r.q8z(tmp_10);
            } else {
              if (r instanceof Remedy()) {
                // Inline function 'com.lightningkite.reactive.context.invoke' call
                var this_4 = $this.wgn_1;
                var tmp_12 = await_1(this_4, $completion);
                if (tmp_12 === get_COROUTINE_SUSPENDED())
                  tmp_12 = yield tmp_12;
                var tmp_13 = tmp_12;
                var tmp$ret$4 = tmp_13 == null ? null : tmp_13.y5r_1;
                tmp_7 = r.n9f(VOID, tmp$ret$4);
              } else {
                tmp_7 = r;
              }
            }
          }
        }
      }
    }
    tmp_2 = serializable(tmp_7);
  }
  var tmp_14 = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_5 = $this.ugn_1;
  var tmp_15 = await_1(this_5, $completion);
  if (tmp_15 === get_COROUTINE_SUSPENDED())
    tmp_15 = yield tmp_15;
  var tmp_16 = tmp_15;
  var tmp_17 = resolveProjectAttachments($this.vgn_1, $completion);
  if (tmp_17 === get_COROUTINE_SUSPENDED())
    tmp_17 = yield tmp_17;
  var tmp_18 = tmp_0.ifl(new (IncidentMessage())(VOID, tmp_1, $this.cgn_1.v7a_1, $this.hgn_1, session.gfv_1, tmp_14, tmp_16, tmp_17), $completion);
  if (tmp_18 === get_COROUTINE_SUSPENDED())
    tmp_18 = yield tmp_18;
  var sent = tmp_18;
  var tmp_19 = session.jfw_1.deo($completion);
  if (tmp_19 === get_COROUTINE_SUSPENDED())
    tmp_19 = yield tmp_19;
  var tmp_20 = session.ifw_1.deo($completion);
  if (tmp_20 === get_COROUTINE_SUSPENDED())
    tmp_20 = yield tmp_20;
  session.jfw_1.dft(sent);
  return Unit_instance;
}
function _get_outerPadding__4anaiz($this, _this__u8e3s4) {
  return get_viewIsNarrow(_this__u8e3s4) ? null : get_AppDimensions().yg1_1;
}
function outerPadding($this, _this__u8e3s4) {
  var tmp0_safe_receiver = _get_outerPadding__4anaiz($this, _this__u8e3s4);
  var tmp = tmp0_safe_receiver;
  if ((tmp == null ? null : new (Dimension())(tmp)) == null)
    null;
  else {
    var tmp_0 = tmp0_safe_receiver;
    // Inline function 'kotlin.let' call
    var it = (tmp_0 == null ? null : new (Dimension())(tmp_0)).yb1_1;
    space(_this__u8e3s4, it);
  }
}
function closeForm($this, _this__u8e3s4) {
  get_dialogStack().wgg();
  if (lastOrNull(get_mainPageNavigator(_this__u8e3s4).ibn_1.f2()) === $this) {
    get_mainPageNavigator(_this__u8e3s4).td6();
  }
}
function page($this, _this__u8e3s4) {
  var tmp = get_unpadded(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_px(0));
  var tmp0_safe_receiver = _get_outerPadding__4anaiz($this, view);
  var tmp_0 = tmp0_safe_receiver;
  if ((tmp_0 == null ? null : new (Dimension())(tmp_0)) == null)
    null;
  else {
    var tmp_1 = tmp0_safe_receiver;
    // Inline function 'kotlin.let' call
    var it = (tmp_1 == null ? null : new (Dimension())(tmp_1)).yb1_1;
    space(view, div(it, 4));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  view_0.bb9(get_px(0));
  outerPadding($this, view_0);
  var tmp_2 = view_0.kbb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(5)), get_expanding(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  var tmp_3 = view_1.kbb(get_expanding(view_1), get_compact(view_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(false);
  var tmp_4 = get_centered(view_2);
  var tmp_5 = get_rem_0(1.25);
  view_2.lbb(tmp_4, actionIcon(view_2, tmp_5, ($this$actionIcon) => {
    var tmp;
    if ($this.dgn_1 == null || !$this.mgn_1.u9d_1) {
      tmp = null;
    } else {
      var tmp0_subject = $this.mgn_1.l8w();
      tmp = (tmp0_subject == null ? -1 : tmp0_subject.b4_1) === 2 ? ActionImportance_Critical_getInstance() : ActionImportance_Important_getInstance();
    }
    return tmp;
  }));
  var tmp_6 = get_centered(view_2);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.lba(view_3.qb6_1.abf(SubtitleSemantic_getInstance()));
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this.dgn_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h63_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.g9f_1;
    var tmp;
    if (tmp2_elvis_lhs == null) {
      var tmp3_safe_receiver = $this$reactiveScope.daj($this.qgn_1);
      tmp = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.g9f_1;
    } else {
      tmp = tmp2_elvis_lhs;
    }
    var tmp4_elvis_lhs = tmp;
    var tmp$ret$2 = 'Concern: ' + (tmp4_elvis_lhs == null ? '' : tmp4_elvis_lhs);
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  view_2.hbb(p_3, view_3);
  view_2.lbb(tmp_6, view_3);
  view_2.lbb(get_centered(view_2), escalationIcon(view_2, $this.zgn_1, get_rem_0(1.25)));
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_3, view_2);
  var tmp_9 = view_1.kbb(view_1.kbb(get_centered(view_1), sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, get_rem(7))), get_compact(view_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_4 = view_1.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
  view_1.gbb(p_4, view_4);
  view_4.zbm(true);
  view_4.bb9(get_dp(2));
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(SubtitleSemantic_getInstance()));
  view_5.dbs(Align_Center_getInstance());
  var tmp0_safe_receiver_0 = $this.lgn_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.c68_1;
  var tmp_10;
  if (tmp1_elvis_lhs == null) {
    // Inline function 'com.lightningkite.now' call
    tmp_10 = get_default(Companion_instance_0).b1m();
  } else {
    tmp_10 = tmp1_elvis_lhs;
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = format(tmp_10, Formats_getInstance().h8z_1);
  var tmp_11 = view_5.vb5_1;
  var tmp_12;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_12 = '\xA0';
  } else {
    tmp_12 = value;
  }
  tmp_11.hbu(tmp_12);
  view_4.hbb(p_5, view_5);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.gbb(p_6, view_6);
  view_6.lba(view_6.qb6_1.abf(SubtitleSemantic_getInstance()));
  view_6.dbs(Align_Center_getInstance());
  var tmp0_safe_receiver_1 = $this.lgn_1;
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.c68_1;
  var tmp_13;
  if (tmp1_elvis_lhs_0 == null) {
    // Inline function 'com.lightningkite.now' call
    tmp_13 = get_default(Companion_instance_0).b1m();
  } else {
    tmp_13 = tmp1_elvis_lhs_0;
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value_0 = format(tmp_13, Formats_getInstance().j8z_1);
  var tmp_14 = view_6.vb5_1;
  var tmp_15;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value_0) === 0) {
    tmp_15 = '\xA0';
  } else {
    tmp_15 = value_0;
  }
  tmp_14.hbu(tmp_15);
  view_4.hbb(p_6, view_6);
  view_1.hbb(p_4, view_4);
  view_1.lbb(tmp_9, view_4);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_2, view_1);
  outerPadding($this, view_0);
  view.hbb(p_0, view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Separator())(view.pc());
  var tmp0_elvis_lhs_7 = view.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
  view.gbb(p_7, view_7);
  view.hbb(p_7, view_7);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_8 = view.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
  view.gbb(p_8, view_8);
  view_8.zbm(false);
  view_8.bb9(get_px(0));
  outerPadding($this, view_8);
  var tmp_16 = get_expanding(view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.gbb(p_9, view_9);
  view_9.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Space())(view_9.pc(), 0.2);
  var tmp0_elvis_lhs_10 = view_9.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
  view_9.gbb(p_10, view_10);
  view_9.hbb(p_10, view_10);
  view_9.bb9(get_AppDimensions().bg2_1);
  renderBanners(view_9, $this.bgo_1);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!$this.egn_1.i1()) {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_11 = new (RowOrCol())(view_9.pc());
    var tmp0_elvis_lhs_11 = view_9.ebb_1;
    var p_11 = tmp0_elvis_lhs_11 == null ? view_9 : tmp0_elvis_lhs_11;
    view_9.gbb(p_11, view_11);
    view_11.zbm(true);
    launch(view_11, VOID, VOID, IncidentReportForm$page$slambda_0(view_11, $this));
    if ($this.egn_1.p1() > 1) {
      var tmp_17 = get_outlined(view_11);
      // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_12 = new (Frame())(view_11.pc());
      var tmp0_elvis_lhs_12 = view_11.ebb_1;
      var p_12 = tmp0_elvis_lhs_12 == null ? view_11 : tmp0_elvis_lhs_12;
      view_11.gbb(p_12, view_12);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_13 = new (RowOrCol())(view_12.pc());
      var tmp0_elvis_lhs_13 = view_12.ebb_1;
      var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
      view_12.gbb(p_13, view_13);
      view_13.zbm(true);
      view_13.bb9(get_px(0));
      leftExpandButton(view_13, $this.ago_1, false, VOID, VOID, VOID, IncidentReportForm$page$lambda);
      var tmp_18 = shownWhen(view_13, VOID, ($this$shownWhen) => $this$shownWhen.daj($this.ago_1));
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_14 = new (RowOrCol())(view_13.pc());
      var tmp0_elvis_lhs_14 = view_13.ebb_1;
      var p_14 = tmp0_elvis_lhs_14 == null ? view_13 : tmp0_elvis_lhs_14;
      view_13.gbb(p_14, view_14);
      view_14.zbm(true);
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_15 = new (Space())(view_14.pc(), 0.0);
      var tmp0_elvis_lhs_15 = view_14.ebb_1;
      var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
      view_14.gbb(p_15, view_15);
      view_14.hbb(p_15, view_15);
      previousMessages($this, view_14);
      view_13.hbb(p_14, view_14);
      view_13.lbb(tmp_18, view_14);
      view_12.hbb(p_13, view_13);
      view_11.hbb(p_12, view_12);
      view_11.lbb(tmp_17, view_12);
    }
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!$this.egn_1.i1()) {
      var tmp_19 = get_outlined(view_11);
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_16 = new (RowOrCol())(view_11.pc());
      var tmp0_elvis_lhs_16 = view_11.ebb_1;
      var p_16 = tmp0_elvis_lhs_16 == null ? view_11 : tmp0_elvis_lhs_16;
      view_11.gbb(p_16, view_16);
      view_16.zbm(true);
      boldSubTitle(view_16, 'Most Recent Response');
      renderMessage($this, view_16, last($this.egn_1), !$this.mgn_1.u9d_1);
      view_11.hbb(p_16, view_16);
      view_11.lbb(tmp_19, view_16);
    }
    view_9.hbb(p_11, view_11);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_17 = new (RowOrCol())(view_9.pc());
  var tmp0_elvis_lhs_17 = view_9.ebb_1;
  var p_17 = tmp0_elvis_lhs_17 == null ? view_9 : tmp0_elvis_lhs_17;
  view_9.gbb(p_17, view_17);
  view_17.zbm(true);
  view_17.bb9(get_AppDimensions().zg1_1);
  if ($this.ygn_1) {
    responseForm$default($this, view_17);
  }
  actionBar_0($this, view_17);
  view_9.hbb(p_17, view_17);
  view_8.hbb(p_9, view_9);
  view_8.lbb(tmp_16, view_9);
  outerPadding($this, view_8);
  view.hbb(p_8, view_8);
  outerPadding($this, view);
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function fileConcernSelector($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  var $this$col = view;
  reactive($this$col, ($this$reactive) => {
    $this$col.bba();
    var tmp;
    if (!$this$reactive.daj($this.ngn_1)) {
      // Inline function 'com.lightningkite.kiteui.views.direct.col' call
      var this_0 = $this$col;
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())(this_0.pc());
      var tmp0_elvis_lhs = this_0.ebb_1;
      var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
      this_0.gbb(p, view);
      view.zbm(true);
      if ($this.mgn_1.v9d_1) {
        var tmp_0 = get_compact(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(false);
        var tmp_1 = get_centered(view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Checkbox())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.gbb(p_1, view_1);
        view_1.zah(view_1.ebk_1, $this.rgn_1);
        view_0.hbb(p_1, view_1);
        view_0.lbb(tmp_1, view_1);
        view_0.lbb(get_centered(view_0), body(view_0, 'Raise Issue'));
        view_0.lbb(get_centered(view_0), infoBubble(view_0, 'Formally notifies the contractor and requires their response. Use when you need the contractor to address the concern, not just document it.'));
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
      }
      renderBanners_0(view, VOID, VOID, ($this$renderBanners) => banners(($this$banners) => {
        var tmp;
        if ($this$renderBanners.daj($this.rgn_1)) {
          $this$banners.ag0('File-Incident-Issue-Warn', 'This formally notifies the contractor and requires their response. The contractor will have options to address your concerns or explain their position.');
          tmp = Unit_instance;
        } else {
          $this$banners.zfz('Report-Incident-Info', 'Reporting an Incident alerts contractor for documentation purposes, or can be raised to an Issue, which formally notices the contractor and requires a response.');
          tmp = Unit_instance;
        }
        return Unit_instance;
      }));
      // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
      var tmp_2 = view.jbb(FieldSemantic_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.select' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Select())(view.pc());
      var tmp0_elvis_lhs_2 = view.ebb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
      view.gbb(p_2, view_2);
      var tmp_3 = assertNotNull($this.qgn_1, 'Required');
      var tmp_4 = _Constant___init__impl__v45mub(plus(listOf(null), get_entries()));
      view_2.ocf(tmp_3, new (Constant())(tmp_4), IncidentReportForm$fileConcernSelector$lambda$lambda);
      view.hbb(p_2, view_2);
      view.lbb(tmp_2, view_2);
      this_0.hbb(p, view);
      tmp = view;
    } else {
      tmp = resolutionSelector($this, $this$col);
    }
    return tmp;
  });
  _this__u8e3s4.hbb(p, view);
}
function resolutionSelector($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label = 'Response Type';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.bb9(get_AppDimensions().rg2_1);
  view_1.lbb(get_centered(view_1), bodyBold(view_1, label));
  view_1.lbb(colored(view_1, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_1, '*'));
  view_0.hbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp = view_0.jbb(FieldSemantic_getInstance());
  var options = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if ($this.hgn_1) {
      tmp = listOf(new (ClientResponse())(VOID, true));
    } else if ($this.mgn_1.s9d_1) {
      tmp = listOf(new (Handled())());
    } else {
      // Inline function 'kotlin.takeUnless' call
      var this_0 = new (Handled())();
      var tmp_0;
      if (!($this.mgn_1.t8w() || $this.mgn_1.w9d_1)) {
        tmp_0 = this_0;
      } else {
        tmp_0 = null;
      }
      var tmp_1 = tmp_0;
      // Inline function 'kotlin.takeIf' call
      var tmp_2;
      if ($this.mgn_1.b8y()) {
        tmp_2 = MoreInfo_instance;
      } else {
        tmp_2 = null;
      }
      var tmp0_safe_receiver = tmp_2;
      var tmp_3;
      if (tmp0_safe_receiver == null) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.takeUnless' call
        var tmp_4;
        if (!($this.mgn_1.t8w() || $this.mgn_1.w9d_1)) {
          tmp_4 = tmp0_safe_receiver;
        } else {
          tmp_4 = null;
        }
        tmp_3 = tmp_4;
      }
      var tmp_5 = tmp_3;
      var tmp_6 = new (Remedy())();
      var tmp_7 = new (Credit_0())(Companion_instance.r91(0n));
      var tmp_8 = new (RequestSiteVisit())();
      // Inline function 'kotlin.takeIf' call
      var tmp_9;
      if ($this.mgn_1.t8w()) {
        tmp_9 = Appeal_instance;
      } else {
        tmp_9 = null;
      }
      var tmp$ret$12 = tmp_9;
      tmp = listOfNotNull([tmp_1, tmp_5, tmp_6, tmp_7, tmp_8, tmp$ret$12, NotResponsible_instance]);
    }
    return tmp;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.select' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Select())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  var tmp_0 = lens(options, IncidentReportForm$resolutionSelector$lambda);
  view_2.ocf($this.pgn_1, tmp_0, (it) => {
    var tmp1_elvis_lhs = it == null ? null : it.c9f($this.mgn_1.p9d_1);
    return tmp1_elvis_lhs == null ? 'Select Resolution' : tmp1_elvis_lhs;
  });
  view_0.hbb(p_2, view_2);
  view_0.lbb(tmp, view_2);
  view.hbb(p_0, view_0);
  var tmp_1 = shownWhen(view, VOID, ($this$shownWhen) => {
    var tmp = $this$shownWhen.daj($this.pgn_1);
    return tmp instanceof Remedy();
  });
  // Inline function 'com.crowpay.views.components.requiredField' call
  var label_0 = 'Due Date';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view_3.zbm(true);
  view_3.bb9(get_AppDimensions().pg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  view_4.zbm(false);
  view_4.bb9(get_AppDimensions().rg2_1);
  view_4.lbb(get_centered(view_4), bodyBold(view_4, label_0));
  view_4.lbb(colored(view_4, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_4, '*'));
  view_3.hbb(p_4, view_4);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_2 = view_3.jbb(FieldSemantic_getInstance());
  var zone = Companion_getInstance_1().o27();
  // Inline function 'com.lightningkite.now' call
  var now = get_default(Companion_instance_0).b1m();
  var tmp_3 = IncidentReportForm$resolutionSelector$lambda_0;
  var tmp_4 = $this.pgn_1.dak(tmp_3, IncidentReportForm$resolutionSelector$lambda_1);
  var tmp_5 = IncidentReportForm$resolutionSelector$lambda_2;
  var tmp_6 = tmp_4.dak(tmp_5, IncidentReportForm$resolutionSelector$lambda_3);
  var tmp_7 = (it) => {
    var tmp1_safe_receiver = it == null ? null : toLocalDateTime(it, zone);
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver.t1w();
  };
  var due = tmp_6.vak(tmp_7, (it) => {
    var tmp1_safe_receiver = it == null ? null : atTime(it, 23, 59);
    return tmp1_safe_receiver == null ? null : toInstant(tmp1_safe_receiver, zone);
  });
  assertReactive(due, 'Must be greater than now', VOID, ($this$assertReactive, it) => {
    var tmp = $this$assertReactive.daj($this.pgn_1);
    var tmp0_safe_receiver = tmp instanceof Remedy() ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = tmp0_safe_receiver.l9f_1.w26(now) >= 0;
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  });
  var tmp_8 = get_compact(view_3);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$30 = view_3.jbb(FieldSemantic_getInstance());
  var tmp_9 = view_3.kbb(view_3.kbb(tmp_8, tmp$ret$30), validate(view_3, due));
  // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (LocalDateField())(view_3.pc());
  var tmp0_elvis_lhs_5 = view_3.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
  view_3.gbb(p_5, view_5);
  view_5.zah(view_5.nby_1, due);
  view_3.hbb(p_5, view_5);
  var tmp$ret$34 = view_3.lbb(tmp_9, view_5);
  view_3.lbb(tmp_2, tmp$ret$34);
  view.hbb(p_3, view_3);
  view.lbb(tmp_1, view_3);
  var tmp_10 = shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.let' call
    var it = $this$shownWhen.daj($this.pgn_1);
    var tmp;
    var tmp_0;
    if (it instanceof Credit_0()) {
      tmp_0 = true;
    } else {
      tmp_0 = it instanceof Remedy();
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = it instanceof Handled();
    }
    return tmp;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_6 = view.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.gbb(p_6, view_6);
  view_6.zbm(true);
  view_6.bb9(get_AppDimensions().rg2_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.gbb(p_7, view_7);
  view_7.zbm(false);
  view_7.bb9(get_AppDimensions().rg2_1);
  view_7.lbb(get_centered(view_7), bodyBold(view_7, 'Credit'));
  var tmp_11 = colored(view_7, AppColors_getInstance().jfz_1.zg9_1);
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view_7.pc());
  var tmp0_elvis_lhs_8 = view_7.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_7 : tmp0_elvis_lhs_8;
  view_7.gbb(p_8, view_8);
  view_8.lba(view_8.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_12 = view_8.vb5_1;
  var tmp_13;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('*') === 0) {
    tmp_13 = '\xA0';
  } else {
    tmp_13 = '*';
  }
  tmp_12.hbu(tmp_13);
  var tmp_14 = KMutableProperty0();
  var tmp_15 = TextView$_get_shown_$ref_kipsub(view_8);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp_14, tmp_15, TextView$_set_shown_$ref_l7jsq9(view_8));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var tmp = $this$reactiveScope.daj($this.pgn_1);
    var tmp$ret$44 = tmp instanceof Credit_0();
    this_0.set(tmp$ret$44);
    return Unit_instance;
  });
  view_7.hbb(p_8, view_8);
  view_7.lbb(tmp_11, view_8);
  view_6.hbb(p_7, view_7);
  var tmp_16 = get_compact(view_6);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp$ret$55 = view_6.jbb(FieldSemantic_getInstance());
  var tmp_17 = view_6.kbb(view_6.kbb(tmp_16, tmp$ret$55), validate_0(view_6, $this.xgn_1));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (RowOrCol())(view_6.pc());
  var tmp0_elvis_lhs_9 = view_6.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_6 : tmp0_elvis_lhs_9;
  view_6.gbb(p_9, view_9);
  view_9.zbm(false);
  var tmp_18 = view_9.kbb(get_centered(view_9), get_compact(view_9));
  // Inline function 'com.crowpay.views.components.monetaryValueInput' call
  // Inline function 'kotlin.also' call
  var this_1 = new (MonetaryValueInput())(view_9);
  this_1.kg9_1 = MonetaryValue__rangeTo_impl_1k0odj(Companion_instance.m62(0), Companion_instance.m62(2147483647));
  view_9.zah(this_1.ig9_1, zeroToNull($this.wgn_1));
  this_1.vcl('Max ' + MonetaryValue__toString_impl_xslc77($this.jgn_1));
  var tmp$ret$58 = this_1.lg9_1;
  view_9.lbb(tmp_18, tmp$ret$58);
  view_6.hbb(p_9, view_9);
  view_6.lbb(tmp_17, view_9);
  view.hbb(p_6, view_6);
  view.lbb(tmp_10, view_6);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function previousMessages($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = $this.egn_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    renderMessage$default($this, view, element);
  }
  _this__u8e3s4.hbb(p, view);
  return view;
}
function renderMessage($this, _this__u8e3s4, message, showReplies) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  view.bb9(get_AppDimensions().og2_1);
  var tmp = view.jbb(FormMessage_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  view_0.bb9(get_dp(0));
  var snapshot = $this.mgn_1.p9d_1.g8x(message.c68_1);
  var state = displayState(snapshot.f8x());
  // Inline function 'com.lightningkite.kiteui.views.card' call
  var tmp_0 = view_0.jbb(CardSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.lbb(view_1.kbb(view_1.kbb(get_centered(view_1), get_expanding(view_1)), view_1.jbb(IncidentStateSemantic(state).abf(BoldSemantic_getInstance()))), body(view_1, state.y9c_1));
  view_1.lbb(get_centered(view_1), escalationIcon(view_1, new (Constant())(_Constant___init__impl__v45mub(snapshot.l8w()))));
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_0, view_1);
  var tmp_1 = get_padded(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  view_2.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.zbm(false);
  bodyBold(view_3, message.x67_1 ? $this.fgn_1.d5c_1 : $this.ggn_1.v5i_1);
  smallBody(view_3, format(message.c68_1, Formats_getInstance().i8z_1));
  view_2.hbb(p_3, view_3);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.gbb(p_4, view_4);
  view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_2;
  // Inline function 'kotlin.text.count' call
  var count = 0;
  var indexedObject = message.a68_1;
  var inductionVariable = 0;
  while (inductionVariable < charSequenceLength(indexedObject)) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (isWhitespace(element)) {
      count = count + 1 | 0;
    }
  }
  if (count / message.a68_1.length < 0.001) {
    tmp_2 = WordBreak_BreakAll_getInstance();
  } else {
    tmp_2 = WordBreak_Normal_getInstance();
  }
  view_4.bcp(tmp_2);
  inlineLabel(view_4, message.h94().b9f(snapshot.h8x(message.c68_1)), message.a68_1);
  view_2.hbb(p_4, view_4);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!message.b68_1.i1()) {
    label2(view_2, 'Attachments', VOID, ($this$label2) => renderFiles($this$label2, new (Constant())(_Constant___init__impl__v45mub(message.b68_1)), get_rem(5)));
  }
  view_0.hbb(p_2, view_2);
  view_0.lbb(tmp_1, view_2);
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  if (showReplies) {
    renderReplies($this, view, message);
  }
  _this__u8e3s4.hbb(p, view);
}
function renderMessage$default($this, _this__u8e3s4, message, showReplies, $super) {
  showReplies = showReplies === VOID ? true : showReplies;
  return renderMessage($this, _this__u8e3s4, message, showReplies);
}
function renderReplies($this, _this__u8e3s4, message) {
  var messageReplies = lensFilter($this.kgn_1, (it) => it.r65_1.equals(message.u67_1));
  var viewReplies = MutableRemember().tak(VOID, VOID, VOID, VOID, ($this$MutableRemember) => {
    var userId = $this$MutableRemember.daj(get_session()).gfv_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$MutableRemember.daj($this.kgn_1);
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.r65_1.equals(message.u67_1)) {
        destination.v(element);
      }
    }
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(destination, Collection())) {
        tmp = destination.i1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$3 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = destination.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        if (!element_0.v92().t1(userId)) {
          tmp$ret$3 = true;
          break $l$block_0;
        }
      }
      tmp$ret$3 = false;
    }
    return tmp$ret$3;
  });
  var newReply = Signal().hak(null);
  var tmp = get_compact(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  var tmp_0 = view.kbb(get_expanding(view), view.jbb(SmallBodySemantic_getInstance()));
  view.lbb(tmp_0, leftExpandButton(view, viewReplies, false, VOID, VOID, VOID, ($this$leftExpandButton) => {
    var tmp = get_centered($this$leftExpandButton);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$leftExpandButton.pc());
    var tmp0_elvis_lhs = $this$leftExpandButton.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$leftExpandButton : tmp0_elvis_lhs;
    $this$leftExpandButton.gbb(p, view);
    var tmp_0 = KMutableProperty0();
    var tmp_1 = TextView$_get_content_$ref_4pzcwl_0(view);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb_0(view));
    reactiveScope(view, ($this$reactiveScope) => {
      // Inline function 'kotlin.let' call
      var it = $this$reactiveScope.daj(messageReplies).p1();
      var tmp$ret$7 = it === 0 ? 'No Replies' : it === 1 ? '1 Reply' : '' + it + ' Replies';
      this_0.set(tmp$ret$7);
      return Unit_instance;
    });
    $this$leftExpandButton.hbb(p, view);
    $this$leftExpandButton.lbb(tmp, view);
    return Unit_instance;
  }));
  var tmp_1 = get_textButton(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  var tmp_2 = KMutableProperty0();
  var tmp_3 = Button$_get_shown_$ref_hkylj1(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp_2, tmp_3, Button$_set_shown_$ref_bpvuvj(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$12 = $this$reactiveScope.daj(messageReplies).i1();
    this_0.set(tmp$ret$12);
    return Unit_instance;
  });
  smallBody(view_0, 'Reply');
  onClick(view_0, VOID, VOID, IncidentReportForm$renderReplies$slambda_0(viewReplies, newReply));
  view.hbb(p_0, view_0);
  view.lbb(tmp_1, view_0);
  _this__u8e3s4.hbb(p, view);
  _this__u8e3s4.lbb(tmp, view);
  var tmp_4 = shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => $this$shownWhen.daj(viewReplies));
  var tmp2 = Indent_Section_getInstance().agr_1;
  // Inline function 'com.crowpay.views.components.indentedCol' call
  var afterSpace = get_px(0);
  var tmp_5 = get_unpadded(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs_1 = _this__u8e3s4.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
  _this__u8e3s4.gbb(p_1, view_1);
  var tmp_6;
  var tmp_7 = null;
  if (!((tmp_7 == null ? null : new (Dimension())(tmp_7)) == null)) {
    tmp_6 = sizeConstraints(view_1, VOID, VOID, VOID, VOID, VOID, null);
  } else {
    tmp_6 = Companion_getInstance_2();
  }
  var tmp_8 = view_1.kbb(tmp_6, indented(view_1, tmp2, afterSpace));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.zbm(true);
  view_3.bb9(times(view_3.mba().jb0_1, 1.4));
  forEachUpdating(view_3, messageReplies, VOID, ($this$forEachUpdating, reply) => {
    var tmp = get_compact($this$forEachUpdating);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEachUpdating.pc());
    var tmp0_elvis_lhs = $this$forEachUpdating.ebb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
    $this$forEachUpdating.gbb(p, view);
    view.zbm(true);
    view.bb9(get_AppDimensions().rg2_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(false);
    var tmp_0 = view_0.kbb(get_atTopStart(view_0), colored(view_0, AppColors_getInstance().jfz_1.zg9_1));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_1 = view_1.vb5_1;
    var tmp_2;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength('\u2022') === 0) {
      tmp_2 = '\xA0';
    } else {
      tmp_2 = '\u2022';
    }
    tmp_1.hbu(tmp_2);
    var tmp_3 = KMutableProperty0();
    var tmp_4 = TextView$_get_shown_$ref_kipsub_0(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp_3, tmp_4, TextView$_set_shown_$ref_l7jsq9_0(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp$ret$23 = !$this$reactiveScope.daj(reply).v92().t1($this$reactiveScope.daj(get_session()).gfv_1);
      this_0.set(tmp$ret$23);
      return Unit_instance;
    });
    view_0.hbb(p_1, view_1);
    view_0.lbb(tmp_0, view_1);
    var tmp_5 = get_centered(view_0);
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.gbb(p_2, view_2);
    view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
    var tmp_6 = KMutableProperty0();
    var tmp_7 = TextView$_get_content_$ref_4pzcwl_1(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_6, tmp_7, TextView$_set_content_$ref_pketfb_1(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$30 = $this$reactiveScope.daj(reply).v65_1;
      this_1.set(tmp$ret$30);
      return Unit_instance;
    });
    view_0.hbb(p_2, view_2);
    view_0.lbb(tmp_5, view_2);
    var tmp_8 = get_centered(view_0);
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_3 = view_0.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
    view_0.gbb(p_3, view_3);
    view_3.lba(view_3.qb6_1.abf(SmallBodySemantic_getInstance()));
    var tmp_9 = KMutableProperty0();
    var tmp_10 = TextView$_get_content_$ref_4pzcwl_2(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_9, tmp_10, TextView$_set_content_$ref_pketfb_2(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      var tmp$ret$37 = format($this$reactiveScope.daj(reply).z65_1, Formats_getInstance().i8z_1);
      this_2.set(tmp$ret$37);
      return Unit_instance;
    });
    view_0.hbb(p_3, view_3);
    view_0.lbb(tmp_8, view_3);
    view.hbb(p_0, view_0);
    var tmp_11 = get_lightSection(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_4 = view.ebb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
    view.gbb(p_4, view_4);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(view_4.pc());
    var tmp0_elvis_lhs_5 = view_4.ebb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
    view_4.gbb(p_5, view_5);
    view_5.zbm(true);
    view_5.bb9(get_px(0));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_6 = new (TextView())(view_5.pc());
    var tmp0_elvis_lhs_6 = view_5.ebb_1;
    var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
    view_5.gbb(p_6, view_6);
    view_6.lba(view_6.qb6_1.abf(BodySemantic_getInstance()));
    var tmp_12 = KMutableProperty0();
    var tmp_13 = TextView$_get_content_$ref_4pzcwl_3(view_6);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_3 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb_3(view_6));
    reactiveScope(view_6, ($this$reactiveScope) => {
      var tmp$ret$48 = $this$reactiveScope.daj(reply).x65_1;
      this_3.set(tmp$ret$48);
      return Unit_instance;
    });
    view_5.hbb(p_6, view_6);
    var tmp_14 = view_5.kbb(get_atEnd(view_5), get_textButton(view_5));
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Button())(view_5.pc());
    var tmp0_elvis_lhs_7 = view_5.ebb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
    view_5.gbb(p_7, view_7);
    view_7.gba(get_dp(2));
    view_7.bb9(get_dp(2));
    shownDefaultFalse(view_7, ($this$shownDefaultFalse) => {
      var tmp0_safe_receiver = lastOrNull($this$shownDefaultFalse.daj(messageReplies));
      return equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q65_1, $this$shownDefaultFalse.daj(reply).q65_1);
    });
    smallBody(view_7, 'Reply');
    onClick(view_7, VOID, VOID, IncidentReportForm$renderReplies$lambda$slambda_0(newReply));
    view_5.hbb(p_7, view_7);
    view_5.lbb(tmp_14, view_7);
    view_4.hbb(p_5, view_5);
    view.hbb(p_4, view_4);
    view.lbb(tmp_11, view_4);
    $this$forEachUpdating.hbb(p, view);
    $this$forEachUpdating.lbb(tmp, view);
    return Unit_instance;
  });
  view_2.hbb(p_3, view_3);
  var tmp_9 = shownWhen(view_2, VOID, ($this$shownWhen) => !($this$shownWhen.daj(newReply) == null));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.gbb(p_4, view_4);
  view_4.zbm(true);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Space())(view_4.pc(), 0.1);
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_4.hbb(p_5, view_5);
  // Inline function 'com.crowpay.views.components.field2' call
  var label = 'New Reply';
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.gbb(p_6, view_6);
  view_6.zbm(true);
  view_6.bb9(get_AppDimensions().pg2_1);
  bodyBold(view_6, label);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  var tmp_10 = view_6.jbb(FieldSemantic_getInstance());
  var tmp_11 = sizeConstraints(view_6, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(8));
  // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (TextArea())(view_6.pc());
  var tmp0_elvis_lhs_7 = view_6.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
  view_6.gbb(p_7, view_7);
  var tmp_12 = IncidentReportForm$renderReplies$lambda;
  view_7.zah(view_7.scl_1, newReply.vak(tmp_12, IncidentReportForm$renderReplies$lambda_0));
  view_6.hbb(p_7, view_7);
  var tmp$ret$80 = view_6.lbb(tmp_11, view_7);
  view_6.lbb(tmp_10, tmp$ret$80);
  view_6.lbb(view_6.jbb(SubtextSemantic_getInstance()), errorText(view_6));
  view_4.hbb(p_6, view_6);
  var tmp_13 = get_atEnd(view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (RowOrCol())(view_4.pc());
  var tmp0_elvis_lhs_8 = view_4.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_4 : tmp0_elvis_lhs_8;
  view_4.gbb(p_8, view_8);
  view_8.zbm(false);
  var tmp_14 = get_secondaryButton(view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (Button())(view_8.pc());
  var tmp0_elvis_lhs_9 = view_8.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
  view_8.gbb(p_9, view_9);
  specCenteredText(view_9, 'Discard');
  onClick(view_9, VOID, VOID, IncidentReportForm$renderReplies$slambda_2(newReply));
  view_8.hbb(p_9, view_9);
  view_8.lbb(tmp_14, view_9);
  var tmp_15 = get_primaryButton(view_8);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Button())(view_8.pc());
  var tmp0_elvis_lhs_10 = view_8.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
  view_8.gbb(p_10, view_10);
  specCenteredText(view_10, 'Send Reply');
  onClick(view_10, VOID, VOID, IncidentReportForm$renderReplies$slambda_4(message, $this, newReply));
  view_8.hbb(p_10, view_10);
  view_8.lbb(tmp_15, view_10);
  view_4.hbb(p_8, view_8);
  view_4.lbb(tmp_13, view_8);
  view_2.hbb(p_4, view_4);
  view_2.lbb(tmp_9, view_4);
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (Space())(view_2.pc(), 0.25);
  var tmp0_elvis_lhs_11 = view_2.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_2 : tmp0_elvis_lhs_11;
  view_2.gbb(p_11, view_11);
  view_2.hbb(p_11, view_11);
  view_1.hbb(p_2, view_2);
  view_1.lbb(tmp_8, view_2);
  _this__u8e3s4.hbb(p_1, view_1);
  var tmp$ret$110 = _this__u8e3s4.lbb(tmp_5, view_1);
  _this__u8e3s4.lbb(tmp_4, tmp$ret$110);
}
function FormAction($this, name, displayName, theme, requiresValidMessage, action) {
  var tmp;
  if (requiresValidMessage) {
    tmp = ($this$ButtonAction) => $this$ButtonAction.daj($this.ogn_1.rat_1).i1();
  } else {
    tmp = null;
  }
  return ButtonAction().fg1(name, theme, displayName, VOID, VOID, tmp, action);
}
function FormAction$default($this, name, displayName, theme, requiresValidMessage, action, $super) {
  displayName = displayName === VOID ? null : displayName;
  theme = theme === VOID ? PrimaryButtonSemantic_getInstance() : theme;
  requiresValidMessage = requiresValidMessage === VOID ? true : requiresValidMessage;
  return FormAction($this, name, displayName, theme, requiresValidMessage, action);
}
function acceptAction($this, _this__u8e3s4, name, proposal, theme) {
  return FormAction$default($this, name, VOID, theme, false, IncidentReportForm$acceptAction$slambda_0(proposal, $this, _this__u8e3s4));
}
function sendResponseConfirmation($this, _this__u8e3s4, header, message, confirmationText, confirmationTheme) {
  var tmp = get_dialogStack();
  var tmp_0 = IncidentReportForm$sendResponseConfirmation$lambda;
  tmp.zgd(new (GenericConfirmationDialog())(header, message, VOID, confirmationText, VOID, confirmationTheme, VOID, VOID, tmp_0, VOID, IncidentReportForm$sendResponseConfirmation$slambda_0($this, _this__u8e3s4)));
}
function sendResponseConfirmation$default($this, _this__u8e3s4, header, message, confirmationText, confirmationTheme, $super) {
  confirmationTheme = confirmationTheme === VOID ? PrimaryButtonSemantic_getInstance() : confirmationTheme;
  return sendResponseConfirmation($this, _this__u8e3s4, header, message, confirmationText, confirmationTheme);
}
function acceptAction_0($this, _this__u8e3s4, proposal, theme) {
  var tmp;
  if (proposal instanceof Handled()) {
    tmp = acceptAction($this, _this__u8e3s4, 'Accept Handled', proposal, theme);
  } else {
    if (proposal instanceof Credit_0()) {
      tmp = acceptAction($this, _this__u8e3s4, 'Accept Credit', proposal, theme);
    } else {
      if (proposal instanceof Remedy()) {
        tmp = acceptAction($this, _this__u8e3s4, 'Accept Remedy', proposal, theme);
      } else {
        if (proposal instanceof RemedyHandled()) {
          tmp = acceptAction($this, _this__u8e3s4, 'Approve Work', proposal, theme);
        } else {
          if (proposal instanceof RequestSiteVisit()) {
            tmp = acceptAction($this, _this__u8e3s4, 'Confirm Visit', proposal, theme);
          } else {
            if (proposal instanceof Appeal()) {
              tmp = acceptAction($this, _this__u8e3s4, 'Accept Appeal', proposal, theme);
            } else {
              if (proposal instanceof NotResponsible()) {
                tmp = acceptAction($this, _this__u8e3s4, 'Accept No Fault', proposal, theme);
              } else {
                if (proposal instanceof ContractorDispute()) {
                  tmp = acceptAction_0($this, _this__u8e3s4, proposal.d9f_1, theme);
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function acceptAction$default($this, _this__u8e3s4, proposal, theme, $super) {
  theme = theme === VOID ? PrimaryButtonSemantic_getInstance() : theme;
  return acceptAction_0($this, _this__u8e3s4, proposal, theme);
}
function primaryResponseAction($this, _this__u8e3s4) {
  return remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if ($this$remember.daj($this.sgn_1)) {
      var tmp_0 = DisputeButton_getInstance();
      tmp = FormAction$default($this, 'File Dispute', VOID, tmp_0, VOID, IncidentReportForm$primaryResponseAction$lambda$slambda_0($this, _this__u8e3s4));
    } else {
      if ($this$remember.daj($this.rgn_1)) {
        var tmp_1 = IssueButton_getInstance();
        tmp = FormAction$default($this, 'Raise Issue', VOID, tmp_1, VOID, IncidentReportForm$primaryResponseAction$lambda$slambda_2($this, _this__u8e3s4));
      } else {
        var tmp_2;
        if ($this.hgn_1) {
          var tmp0_safe_receiver = $this.lgn_1;
          tmp_2 = equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h94(), MoreInfo_instance);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp = FormAction$default($this, 'Provide Info', VOID, VOID, VOID, IncidentReportForm$primaryResponseAction$lambda$slambda_4($this, _this__u8e3s4));
        } else {
          if ($this.hgn_1 && $this.mgn_1.f9e_1 && !($this.mgn_1.d9e_1 == null) && !($this.mgn_1.e9e_1 == null) && !equals($this.mgn_1.d9e_1, $this.mgn_1.e9e_1)) {
            tmp = acceptAction_0($this, _this__u8e3s4, ensureNotNull($this.mgn_1.d9e_1), SecondaryButtonSemantic_getInstance());
          } else {
            if ($this.hgn_1 && $this.mgn_1.e8x().d4(IncidentState_Issue_getInstance()) <= 0 && $this.mgn_1.u9d_1 && !($this.mgn_1.z9d_1 || $this.mgn_1.t8w())) {
              var tmp1_safe_receiver = $this.mgn_1.p9e();
              var tmp2_subject = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h94();
              var tmp_3;
              var tmp_4;
              if (tmp2_subject instanceof Remedy()) {
                tmp_4 = true;
              } else {
                tmp_4 = tmp2_subject instanceof Credit_0();
              }
              if (tmp_4) {
                var tmp_5 = SecondaryButtonSemantic_getInstance();
                tmp_3 = FormAction$default($this, 'Propose', VOID, tmp_5, VOID, IncidentReportForm$primaryResponseAction$lambda$slambda_6(_this__u8e3s4, $this));
              } else {
                var tmp_6 = IssueButton_getInstance();
                tmp_3 = FormAction$default($this, 'Resubmit Issue', VOID, tmp_6, VOID, IncidentReportForm$primaryResponseAction$lambda$slambda_8(_this__u8e3s4, $this));
              }
              tmp = tmp_3;
            } else {
              if (!$this.hgn_1 && $this.mgn_1.u9d_1 && !$this.mgn_1.s9d_1) {
                var actionName = (_this__u8e3s4) => {
                  var tmp0_subject = _this__u8e3s4.daj($this.pgn_1);
                  var tmp;
                  if (equals(tmp0_subject, MoreInfo_instance)) {
                    tmp = 'Request More Info';
                  } else {
                    if (tmp0_subject instanceof Credit_0()) {
                      tmp = 'Submit Credit';
                    } else {
                      if (tmp0_subject instanceof Handled()) {
                        tmp = 'Submit Handled';
                      } else {
                        if (tmp0_subject instanceof Remedy()) {
                          tmp = 'Submit Remedy Plan';
                        } else {
                          if (tmp0_subject instanceof RequestSiteVisit()) {
                            tmp = 'Request Visit';
                          } else {
                            if (tmp0_subject instanceof Appeal()) {
                              tmp = 'Submit Appeal';
                            } else {
                              if (tmp0_subject instanceof NotResponsible()) {
                                tmp = 'Submit No Fault';
                              } else {
                                tmp = 'Select Response';
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                  return tmp;
                };
                tmp = FormAction$default($this, 'Respond', actionName, VOID, VOID, IncidentReportForm$primaryResponseAction$lambda$slambda_10($this$remember, actionName, $this, _this__u8e3s4));
              } else {
                tmp = null;
              }
            }
          }
        }
      }
    }
    return tmp;
  });
}
function lockProjectAction($this, _this__u8e3s4) {
  var tmp;
  if ($this.mgn_1.a9e_1) {
    var tmp_0 = DisputeButton_getInstance();
    var tmp_1 = ($this$ButtonAction) => $this$ButtonAction.daj(get_issues($this.ugn_1)).i1();
    tmp = ButtonAction().fg1('Lock Project', tmp_0, VOID, VOID, VOID, tmp_1, IncidentReportForm$lockProjectAction$slambda_0(_this__u8e3s4, $this));
  } else {
    tmp = null;
  }
  return tmp;
}
function actionBar_0($this, _this__u8e3s4) {
  var primaryAction = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if ($this.dgn_1 == null && !$this$remember.daj($this.rgn_1)) {
      var tmp_0 = NotReadyButton_getInstance();
      tmp = FormAction$default($this, 'Report Incident', VOID, tmp_0, VOID, IncidentReportForm$actionBar$lambda$slambda_0($this, _this__u8e3s4));
    } else if ($this.hgn_1 && $this.mgn_1.f9e_1 && !($this.mgn_1.d9e_1 == null)) {
      var tmp0_elvis_lhs = $this.mgn_1.e9e_1;
      tmp = acceptAction$default($this, _this__u8e3s4, tmp0_elvis_lhs == null ? ensureNotNull($this.mgn_1.d9e_1) : tmp0_elvis_lhs);
    } else if (!$this.hgn_1 && $this.mgn_1.s9d_1 && !($this.dgn_1 == null)) {
      tmp = FormAction$default($this, 'Request Sign-Off', VOID, VOID, false, IncidentReportForm$actionBar$lambda$slambda_2($this));
    } else {
      tmp = null;
    }
    return tmp;
  });
  var pRes = primaryResponseAction($this, _this__u8e3s4);
  var tmp;
  if ($this.ygn_1) {
    tmp = pRes;
  } else {
    tmp = remember(VOID, VOID, VOID, ($this$remember) => {
      var response = $this$remember.daj(pRes);
      var primary = $this$remember.daj(primaryAction);
      var tmp;
      if (!(response == null)) {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = response.zg0_1;
        var tmp_0;
        if (!equals(this_0, primary == null ? null : primary.zg0_1)) {
          tmp_0 = this_0;
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_1 = tmp0_elvis_lhs == null ? SecondaryButtonSemantic_getInstance() : tmp0_elvis_lhs;
        tmp = FormAction$default($this, response.yg0_1, VOID, tmp_1, false, IncidentReportForm$actionBar$lambda$slambda_4($this, pRes));
      } else {
        tmp = null;
      }
      return tmp;
    });
  }
  var secondaryAction = tmp;
  var tmp_0;
  if ($this.hgn_1 && $this.mgn_1.b9e_1) {
    var tmp_1 = SecondaryButtonSemantic_getInstance();
    tmp_0 = FormAction$default($this, 'Propose/Deny', VOID, tmp_1, false, IncidentReportForm$actionBar$slambda_0($this, _this__u8e3s4));
  } else {
    tmp_0 = null;
  }
  var tertiaryAction = tmp_0;
  var tmp0_safe_receiver = lockProjectAction($this, _this__u8e3s4);
  var tmp_2;
  if (tmp0_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_2 = FormAction$default($this, tmp0_safe_receiver.yg0_1, VOID, tmp0_safe_receiver.zg0_1, false, IncidentReportForm$actionBar$slambda_2($this, tmp0_safe_receiver));
  }
  var openLockProjectForm = tmp_2;
  var tmp1_safe_receiver = $this.dgn_1;
  if (!((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.f63_1) == null)) {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.gbb(p, view);
    view.zbm(false);
    var tmp_3 = get_expanding(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Space())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view.hbb(p_0, view_0);
    view.lbb(tmp_3, view_0);
    view.lbb(get_centered(view), actionBar$goBackButton_0(view, $this));
    _this__u8e3s4.hbb(p, view);
  } else {
    if (get_viewIsWide(_this__u8e3s4)) {
      // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
      var breakpoint = get_AppDimensions().ig2_1;
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (RowCollapsingToColumn())(_this__u8e3s4.pc(), listOf(new (Dimension())(breakpoint)));
      var tmp0_elvis_lhs_1 = _this__u8e3s4.ebb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? _this__u8e3s4 : tmp0_elvis_lhs_1;
      _this__u8e3s4.gbb(p_1, view_1);
      view_1.bb9(get_AppDimensions().kg2_1);
      if ($this.ygn_1)
        view_1.lbb(get_tertiaryButton(view_1), attachmentButton($this, view_1));
      else {
        fileDisputeCheckbox($this, view_1);
      }
      var tmp_4 = get_expanding(view_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Space())(view_1.pc());
      var tmp0_elvis_lhs_2 = view_1.ebb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
      view_1.gbb(p_2, view_2);
      view_1.hbb(p_2, view_2);
      view_1.lbb(tmp_4, view_2);
      view_1.lbb(get_centered(view_1), actionBar$goBackButton_0(view_1, $this));
      if (!(openLockProjectForm == null)) {
        view_1.lbb(get_centered(view_1), button(view_1, openLockProjectForm));
      }
      if (!(tertiaryAction == null)) {
        view_1.lbb(get_centered(view_1), button(view_1, tertiaryAction));
      }
      var tmp_5 = get_centered(view_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (Button())(view_1.pc());
      var tmp0_elvis_lhs_3 = view_1.ebb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
      view_1.gbb(p_3, view_3);
      applyReactiveActionFormatting(view_3, secondaryAction);
      view_1.hbb(p_3, view_3);
      view_1.lbb(tmp_5, view_3);
      var tmp_6 = get_centered(view_1);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (Button())(view_1.pc());
      var tmp0_elvis_lhs_4 = view_1.ebb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
      view_1.gbb(p_4, view_4);
      applyReactiveActionFormatting(view_4, primaryAction);
      view_1.hbb(p_4, view_4);
      view_1.lbb(tmp_6, view_4);
      _this__u8e3s4.hbb(p_1, view_1);
    } else {
      if ($this.dgn_1 == null) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs_5 = _this__u8e3s4.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? _this__u8e3s4 : tmp0_elvis_lhs_5;
        _this__u8e3s4.gbb(p_5, view_5);
        view_5.zbm(true);
        view_5.bb9(get_AppDimensions().kg2_1);
        view_5.lbb(get_tertiaryButton(view_5), attachmentButton($this, view_5));
        actionBar$actions(view_5, openLockProjectForm, tertiaryAction, secondaryAction, primaryAction, $this);
        _this__u8e3s4.hbb(p_5, view_5);
      } else {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs_6 = _this__u8e3s4.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? _this__u8e3s4 : tmp0_elvis_lhs_6;
        _this__u8e3s4.gbb(p_6, view_6);
        view_6.zbm(true);
        fileDisputeCheckbox($this, view_6);
        actionBar$actions(view_6, openLockProjectForm, tertiaryAction, secondaryAction, primaryAction, $this);
        _this__u8e3s4.hbb(p_6, view_6);
      }
    }
  }
}
function staticBanners($this, _this__u8e3s4) {
  return renderBanners_1(_this__u8e3s4, banners(($this$banners) => {
    var tmp;
    if (!$this.hgn_1) {
      var tmp_0;
      var tmp_1;
      if ($this.mgn_1.u9d_1) {
        var tmp0_safe_receiver = $this.dgn_1;
        tmp_1 = equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i63_1, IncidentState_Disputed_getInstance());
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        $this$banners.bg0('C-IRF-RF-Disputed-dang', "Disputes require careful consideration. Review the client's concerns thoroughly and propose a fair resolution. If not settled within 14 days, either party can lock the project, requiring independent dispute resolution authority for fund release.");
        tmp_0 = Unit_instance;
      }
      tmp = tmp_0;
    }
    return Unit_instance;
  }));
}
function fileDisputeCheckbox($this, _this__u8e3s4) {
  if ($this.mgn_1.y9d_1) {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.gbb(p, view);
    view.zbm(false);
    var tmp = get_centered(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.checkbox' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Checkbox())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zah(view_0.ebk_1, $this.sgn_1);
    view.hbb(p_0, view_0);
    view.lbb(tmp, view_0);
    view.lbb(get_centered(view), body(view, 'File Dispute'));
    view.lbb(get_centered(view), infoBubble(view, 'Initiates formal dispute period. Applies to the entire project. Parties negotiate through structured options or, after 14 days, either party can lock the project forcing arbitration.'));
    _this__u8e3s4.hbb(p, view);
  }
}
function responseForm($this, _this__u8e3s4, messageRequired, lockingProject) {
  var tmp;
  var tmp0_safe_receiver = $this.dgn_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i63_1;
  if ((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c9d()) === true) {
    tmp = true;
  } else {
    tmp = $this.mgn_1.s9d_1;
  }
  if (tmp)
    return Unit_instance;
  if ($this.mgn_1.h9e_1) {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(_this__u8e3s4.pc());
    var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
    var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
    _this__u8e3s4.gbb(p, view);
    view.zbm(true);
    if (lockingProject instanceof Constant()) {
      if (_Constant___get_value__impl__gl47rj(lockingProject.maq_1))
        title(view, 'Lock Project');
      else
        responseForm$_anonymous_$header_u1yv2b(view, $this);
    } else {
      view.lbb(shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(lockingProject)), title(view, 'Lock Project'));
      view.lbb(shownWhen(view, VOID, ($this$shownWhen) => !$this$shownWhen.daj(lockingProject)), responseForm$_anonymous_$header_u1yv2b(view, $this));
    }
    renderBanners(view, $this.cgo_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    view_0.zbm(true);
    view_0.bb9(get_px(0));
    // Inline function 'com.crowpay.views.components.requiredField' call
    var required = ($this$requiredField) => $this$requiredField.daj(messageRequired);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.gbb(p_1, view_1);
    view_1.zbm(true);
    view_1.bb9(get_AppDimensions().pg2_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.gbb(p_2, view_2);
    view_2.zbm(false);
    view_2.bb9(get_AppDimensions().rg2_1);
    var tmp_0 = get_centered(view_2);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (TextView())(view_2.pc());
    var tmp0_elvis_lhs_3 = view_2.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
    view_2.gbb(p_3, view_3);
    view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
    var tmp_1 = KMutableProperty0();
    var tmp_2 = TextView$_get_content_$ref_4pzcwl_4(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_4(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.daj(lockingProject) ? 'Explain your decision for locking the project' : $this.dgn_1 == null ? 'Elaborate on Concern' : !$this.hgn_1 ? 'Explain your decision or update for this incident.' : 'Explain Response';
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    view_2.hbb(p_3, view_3);
    view_2.lbb(tmp_0, view_3);
    view_2.lbb(view_2.kbb(shownWhen(view_2, VOID, required), colored(view_2, AppColors_getInstance().jfz_1.zg9_1)), bodyBold(view_2, '*'));
    view_1.hbb(p_2, view_2);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_3 = view_1.jbb(FieldSemantic_getInstance());
    var tmp_4 = sizeConstraints(view_1, VOID, VOID, get_rem(10));
    // Inline function 'com.lightningkite.kiteui.views.direct.textArea' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (TextArea())(view_1.pc());
    var tmp0_elvis_lhs_4 = view_1.ebb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
    view_1.gbb(p_4, view_4);
    view_4.vcl($this.hgn_1 ? 'Clearly explain so concerns can be addressed. Min. ' + $this.tgn_1 + ' characters.' : 'Clearly explain your position or how concerns can be addressed. Min. ' + $this.tgn_1 + ' characters.');
    view_4.zah(view_4.scl_1, $this.ugn_1);
    view_1.hbb(p_4, view_4);
    var tmp$ret$15 = view_1.lbb(tmp_4, view_4);
    view_1.lbb(tmp_3, tmp$ret$15);
    view_1.lbb(view_1.jbb(SubtextSemantic_getInstance()), errorText(view_1));
    view_0.hbb(p_1, view_1);
    var tmp_5 = get_atEnd(view_0);
    var tmp_6 = view_0.kbb(tmp_5, shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.daj(messageRequired)));
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_5 = view_0.ebb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_0 : tmp0_elvis_lhs_5;
    view_0.gbb(p_5, view_5);
    view_5.lba(view_5.qb6_1.abf(SmallBodySemantic_getInstance()));
    var tmp_7 = KMutableProperty0();
    var tmp_8 = TextView$_get_content_$ref_4pzcwl_5(view_5);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_5(view_5));
    reactiveScope(view_5, ($this$reactiveScope) => {
      var remaining = $this.tgn_1 - $this$reactiveScope.daj($this.ugn_1).length | 0;
      var tmp$ret$21 = remaining <= 0 ? '' : '(' + remaining + ') more characters required';
      this_1.set(tmp$ret$21);
      return Unit_instance;
    });
    view_0.hbb(p_5, view_5);
    view_0.lbb(tmp_6, view_5);
    view.hbb(p_0, view_0);
    label2(view, 'Attachments', VOID, ($this$label2) => {
      shownDefaultFalse($this$label2, ($this$shownDefaultFalse) => {
        // Inline function 'kotlin.collections.isNotEmpty' call
        return !$this$shownDefaultFalse.daj($this.vgn_1).i1();
      });
      return fileCarousel($this$label2, $this.vgn_1);
    });
    _this__u8e3s4.hbb(p, view);
  }
}
function responseForm$default($this, _this__u8e3s4, messageRequired, lockingProject, $super) {
  messageRequired = messageRequired === VOID ? new (Constant())(_Constant___init__impl__v45mub(true)) : messageRequired;
  lockingProject = lockingProject === VOID ? new (Constant())(_Constant___init__impl__v45mub(false)) : lockingProject;
  return responseForm($this, _this__u8e3s4, messageRequired, lockingProject);
}
function attachmentButton($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  specCenteredText(view, '+ Attachment');
  onClick(view, 'Upload Attachments', VOID, IncidentReportForm$attachmentButton$slambda_0(view, $this));
  _this__u8e3s4.hbb(p, view);
  return view;
}
var ResponseFormClass;
function ResponseForm() {
  if (ResponseFormClass === VOID) {
    class $ {
      constructor($outer, rawAction) {
        this.wgp_1 = $outer;
        this.tgp_1 = rawAction;
        this.ugp_1 = get_waitForNotNull(this.tgp_1);
        var tmp = this;
        var tmp_0;
        var tmp_1 = this.tgp_1;
        if (tmp_1 instanceof Constant()) {
          var tmp0_safe_receiver = _Constant___get_value__impl__gl47rj(this.tgp_1.maq_1);
          tmp_0 = new (Constant())(_Constant___init__impl__v45mub((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wcv()) === 'Lock Project'));
        } else {
          tmp_0 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.ugp_1).wcv() === 'Lock Project');
        }
        tmp.vgp_1 = tmp_0;
      }
      wd6(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.vbo(IncidentReportForm$ResponseForm$render$slambda_0());
        view.gba(get_AppDimensions().yg1_1);
        var tmp_0 = CoroutineScope_0(view.xba());
        reactive(tmp_0, ($this$reactive) => {
          var tmp;
          if ($this$reactive.daj(this.tgp_1) == null) {
            get_dialogStack().pgd();
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        var tmp_1 = view.kbb(view.kbb(get_centered(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, times(get_AppDimensions().gg2_1, 0.75))), view.jbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.zbm(true);
        view_0.bb9(get_AppDimensions().zg1_1);
        responseForm(this.wgp_1, view_0, lens(this.ugp_1, IncidentReportForm$ResponseForm$render$lambda), this.vgp_1);
        actionBar(this, view_0, this.ugp_1);
        view.hbb(p_0, view_0);
        view.lbb(tmp_1, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'ResponseForm', VOID, VOID, [Page()]);
    ResponseFormClass = $;
  }
  return ResponseFormClass;
}
function actionBar$goBackButton_0(_this__u8e3s4, this$0) {
  var tmp = get_textButton(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  specCenteredText(view, 'Go Back');
  onClick(view, VOID, VOID, IncidentReportForm$actionBar$goBackButton$slambda_0(this$0, view));
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function actionBar$actions(_this__u8e3s4, openLockProjectForm, tertiaryAction, secondaryAction, primaryAction, this$0) {
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  view.bb9(get_AppDimensions().kg2_1);
  view.lbb(view.kbb(get_expanding(view), get_centered(view)), actionBar$goBackButton_0(view, this$0));
  if (!(openLockProjectForm == null)) {
    view.lbb(view.kbb(get_expanding(view), get_centered(view)), button(view, openLockProjectForm, false));
  }
  if (!(tertiaryAction == null)) {
    view.lbb(view.kbb(get_expanding(view), get_centered(view)), button(view, tertiaryAction, false));
  }
  var tmp = view.kbb(get_expanding(view), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Button())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  applyReactiveActionFormatting(view_0, secondaryAction, false);
  view.hbb(p_0, view_0);
  view.lbb(tmp, view_0);
  var tmp_0 = view.kbb(get_expanding(view), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Button())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  applyReactiveActionFormatting(view_1, primaryAction, false);
  view.hbb(p_1, view_1);
  view.lbb(tmp_0, view_1);
  _this__u8e3s4.hbb(p, view);
  return view;
}
function responseForm$_anonymous_$header_u1yv2b(_this__u8e3s4, this$0) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(true);
  if (this$0.hgn_1) {
    view.lbb(view.jbb(this$0.ygn_1 ? SubtitleSemantic_getInstance() : TitleSemantic_getInstance()), text(view, this$0.dgn_1 == null ? 'Report To Contractor' : 'Respond to Contractor'));
    staticBanners(this$0, view);
    if (this$0.dgn_1 == null) {
      fileConcernSelector(this$0, view);
    } else {
      fileDisputeCheckbox(this$0, view);
    }
  } else {
    title(view, 'Propose Solution to Client');
    staticBanners(this$0, view);
    resolutionSelector(this$0, view);
  }
  _this__u8e3s4.hbb(p, view);
  return view;
}
var IncidentReportForm$clientConcern$slambdaClass;
function IncidentReportForm$clientConcern$slambda() {
  if (IncidentReportForm$clientConcern$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.cgr_1 = this$0;
      }
      dgr($this$interceptWrite, it, $completion) {
        if (it == null || equals($this$interceptWrite.f2(), it))
          return Unit_instance;
        this.cgr_1.pgn_1.oam(new (FileIncident())(it, this.cgr_1.rgn_1.f2()));
        $this$interceptWrite.oam(it);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof Signal() ? p1 : THROW_CCE();
        return this.dgr(tmp, (p2 == null ? true : p2 instanceof ClientConcern()) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    IncidentReportForm$clientConcern$slambdaClass = $;
  }
  return IncidentReportForm$clientConcern$slambdaClass;
}
function IncidentReportForm$clientConcern$slambda_0(this$0) {
  var i = new (IncidentReportForm$clientConcern$slambda())(this$0);
  var l = ($this$interceptWrite, it, $completion) => i.dgr($this$interceptWrite, it, $completion);
  l.$arity = 2;
  return l;
}
var IncidentReportForm$renderAsDialog$slambdaClass;
function IncidentReportForm$renderAsDialog$slambda() {
  if (IncidentReportForm$renderAsDialog$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$dismissBackground) {
        this.egr_1 = this$0;
        this.fgr_1 = $$this$dismissBackground;
      }
      uao($completion) {
        closeForm(this.egr_1, this.fgr_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$renderAsDialog$slambdaClass = $;
  }
  return IncidentReportForm$renderAsDialog$slambdaClass;
}
function IncidentReportForm$renderAsDialog$slambda_0(this$0, $$this$dismissBackground) {
  var i = new (IncidentReportForm$renderAsDialog$slambda())(this$0, $$this$dismissBackground);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var IncidentReportForm$page$slambdaClass;
function IncidentReportForm$page$slambda() {
  if (IncidentReportForm$page$slambdaClass === VOID) {
    class $ {
      constructor($$this$scope, this$0) {
        this.xgp_1 = $$this$scope;
        this.ygp_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$page$slambdaClass = $;
  }
  return IncidentReportForm$page$slambdaClass;
}
function IncidentReportForm$page$slambda_0($$this$scope, this$0) {
  var i = new (IncidentReportForm$page$slambda())($$this$scope, this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function IncidentReportForm$page$lambda($this$leftExpandButton) {
  boldSubTitle($this$leftExpandButton, 'Form History');
  return Unit_instance;
}
function IncidentReportForm$fileConcernSelector$lambda$lambda(it) {
  var tmp1_elvis_lhs = it == null ? null : it.g9f_1;
  return tmp1_elvis_lhs == null ? 'Select Response' : tmp1_elvis_lhs;
}
function IncidentReportForm$resolutionSelector$lambda(it) {
  return plus(listOf(null), it);
}
function IncidentReportForm$resolutionSelector$lambda_0(it) {
  return it instanceof Remedy() ? it : null;
}
function IncidentReportForm$resolutionSelector$lambda_1(old, r) {
  return r == null ? old : r;
}
function IncidentReportForm$resolutionSelector$lambda_2(it) {
  return it == null ? null : it.l9f_1;
}
function IncidentReportForm$resolutionSelector$lambda_3(o, it) {
  var tmp;
  if (it == null) {
    tmp = o;
  } else {
    tmp = o == null ? null : o.n9f(it);
  }
  return tmp;
}
function TextView$_get_shown_$ref_kipsub(p0) {
  return () => p0.yb8();
}
function TextView$_set_shown_$ref_l7jsq9(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function Button$_get_shown_$ref_hkylj1(p0) {
  return () => p0.yb8();
}
function Button$_set_shown_$ref_bpvuvj(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
var IncidentReportForm$renderReplies$slambdaClass;
function IncidentReportForm$renderReplies$slambda() {
  if (IncidentReportForm$renderReplies$slambdaClass === VOID) {
    class $ {
      constructor($viewReplies, $newReply) {
        this.ggr_1 = $viewReplies;
        this.hgr_1 = $newReply;
      }
      uao($completion) {
        set_value(this.ggr_1, true);
        this.hgr_1.oam('');
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$renderReplies$slambdaClass = $;
  }
  return IncidentReportForm$renderReplies$slambdaClass;
}
function IncidentReportForm$renderReplies$slambda_0($viewReplies, $newReply) {
  var i = new (IncidentReportForm$renderReplies$slambda())($viewReplies, $newReply);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_shown_$ref_kipsub_0(p0) {
  return () => p0.yb8();
}
function TextView$_set_shown_$ref_l7jsq9_0(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var IncidentReportForm$renderReplies$lambda$slambdaClass;
function IncidentReportForm$renderReplies$lambda$slambda() {
  if (IncidentReportForm$renderReplies$lambda$slambdaClass === VOID) {
    class $ {
      constructor($newReply) {
        this.igr_1 = $newReply;
      }
      uao($completion) {
        this.igr_1.oam('');
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$renderReplies$lambda$slambdaClass = $;
  }
  return IncidentReportForm$renderReplies$lambda$slambdaClass;
}
function IncidentReportForm$renderReplies$lambda$slambda_0($newReply) {
  var i = new (IncidentReportForm$renderReplies$lambda$slambda())($newReply);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function IncidentReportForm$renderReplies$lambda(it) {
  return it == null ? '' : it;
}
function IncidentReportForm$renderReplies$lambda_0(it) {
  return it;
}
var IncidentReportForm$renderReplies$slambdaClass_0;
function IncidentReportForm$renderReplies$slambda_1() {
  if (IncidentReportForm$renderReplies$slambdaClass_0 === VOID) {
    class $ {
      constructor($newReply) {
        this.jgr_1 = $newReply;
      }
      uao($completion) {
        this.jgr_1.oam(null);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$renderReplies$slambdaClass_0 = $;
  }
  return IncidentReportForm$renderReplies$slambdaClass_0;
}
function IncidentReportForm$renderReplies$slambda_2($newReply) {
  var i = new (IncidentReportForm$renderReplies$slambda_1())($newReply);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var IncidentReportForm$renderReplies$slambdaClass_1;
function IncidentReportForm$renderReplies$slambda_3() {
  if (IncidentReportForm$renderReplies$slambdaClass_1 === VOID) {
    class $ {
      constructor($message, this$0, $newReply) {
        this.zgp_1 = $message;
        this.agq_1 = this$0;
        this.bgq_1 = $newReply;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$renderReplies$slambdaClass_1 = $;
  }
  return IncidentReportForm$renderReplies$slambdaClass_1;
}
function IncidentReportForm$renderReplies$slambda_4($message, this$0, $newReply) {
  var i = new (IncidentReportForm$renderReplies$slambda_3())($message, this$0, $newReply);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var IncidentReportForm$acceptAction$slambdaClass;
function IncidentReportForm$acceptAction$slambda() {
  if (IncidentReportForm$acceptAction$slambdaClass === VOID) {
    class $ {
      constructor($proposal, this$0, $this_acceptAction) {
        this.kgr_1 = $proposal;
        this.lgr_1 = this$0;
        this.mgr_1 = $this_acceptAction;
      }
      yah($this$FormAction, $completion) {
        var text = invoke$getText(this.lgr_1, this.kgr_1);
        var tmp = get_dialogStack();
        var tmp_0 = IncidentReportForm$acceptAction$slambda$lambda;
        tmp.zgd(new (GenericConfirmationDialog())(text.tw_1, text.uw_1, VOID, text.vw_1, VOID, VOID, VOID, VOID, tmp_0, VOID, IncidentReportForm$acceptAction$slambda$slambda_0(this.lgr_1, this.kgr_1, this.mgr_1)));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$acceptAction$slambdaClass = $;
  }
  return IncidentReportForm$acceptAction$slambdaClass;
}
function IncidentReportForm$acceptAction$slambda_0($proposal, this$0, $this_acceptAction) {
  var i = new (IncidentReportForm$acceptAction$slambda())($proposal, this$0, $this_acceptAction);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
function IncidentReportForm$sendResponseConfirmation$lambda($this$GenericConfirmationDialog) {
  get_dialogStack().pgd();
  return Unit_instance;
}
var IncidentReportForm$sendResponseConfirmation$slambdaClass;
function IncidentReportForm$sendResponseConfirmation$slambda() {
  if (IncidentReportForm$sendResponseConfirmation$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_sendResponseConfirmation) {
        this.ggq_1 = this$0;
        this.hgq_1 = $this_sendResponseConfirmation;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$sendResponseConfirmation$slambdaClass = $;
  }
  return IncidentReportForm$sendResponseConfirmation$slambdaClass;
}
function IncidentReportForm$sendResponseConfirmation$slambda_0(this$0, $this_sendResponseConfirmation) {
  var i = new (IncidentReportForm$sendResponseConfirmation$slambda())(this$0, $this_sendResponseConfirmation);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$primaryResponseAction$lambda$slambdaClass;
function IncidentReportForm$primaryResponseAction$lambda$slambda() {
  if (IncidentReportForm$primaryResponseAction$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.ngr_1 = this$0;
        this.ogr_1 = $this_primaryResponseAction;
      }
      yah($this$FormAction, $completion) {
        sendResponseConfirmation(this.ngr_1, this.ogr_1, 'File Dispute?', 'This escalates to a formal dispute and freezes all work on the project. Parties work together to settle through structured options. If not settled after 14 days, either party can lock the project. After lock, parties can still reach agreement and unlock, or proceed to independent decision.', 'File Dispute', DisputeButton_getInstance());
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$primaryResponseAction$lambda$slambdaClass = $;
  }
  return IncidentReportForm$primaryResponseAction$lambda$slambdaClass;
}
function IncidentReportForm$primaryResponseAction$lambda$slambda_0(this$0, $this_primaryResponseAction) {
  var i = new (IncidentReportForm$primaryResponseAction$lambda$slambda())(this$0, $this_primaryResponseAction);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$primaryResponseAction$lambda$slambdaClass_0;
function IncidentReportForm$primaryResponseAction$lambda$slambda_1() {
  if (IncidentReportForm$primaryResponseAction$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.pgr_1 = this$0;
        this.qgr_1 = $this_primaryResponseAction;
      }
      yah($this$FormAction, $completion) {
        sendResponseConfirmation(this.pgr_1, this.qgr_1, 'Raise Issue?', 'This formally notifies the contractor and requires their response. The contractor will have options to address your concerns, request more information, or explain their position.', 'Raise Issue', IssueButton_getInstance());
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$primaryResponseAction$lambda$slambdaClass_0 = $;
  }
  return IncidentReportForm$primaryResponseAction$lambda$slambdaClass_0;
}
function IncidentReportForm$primaryResponseAction$lambda$slambda_2(this$0, $this_primaryResponseAction) {
  var i = new (IncidentReportForm$primaryResponseAction$lambda$slambda_1())(this$0, $this_primaryResponseAction);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$primaryResponseAction$lambda$slambdaClass_1;
function IncidentReportForm$primaryResponseAction$lambda$slambda_3() {
  if (IncidentReportForm$primaryResponseAction$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $this_primaryResponseAction) {
        this.rgr_1 = this$0;
        this.sgr_1 = $this_primaryResponseAction;
      }
      yah($this$FormAction, $completion) {
        sendResponseConfirmation$default(this.rgr_1, this.sgr_1, 'Provide Info?', 'Provide info confirmation text.', 'Provide Info');
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$primaryResponseAction$lambda$slambdaClass_1 = $;
  }
  return IncidentReportForm$primaryResponseAction$lambda$slambdaClass_1;
}
function IncidentReportForm$primaryResponseAction$lambda$slambda_4(this$0, $this_primaryResponseAction) {
  var i = new (IncidentReportForm$primaryResponseAction$lambda$slambda_3())(this$0, $this_primaryResponseAction);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$primaryResponseAction$lambda$slambdaClass_2;
function IncidentReportForm$primaryResponseAction$lambda$slambda_5() {
  if (IncidentReportForm$primaryResponseAction$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($this_primaryResponseAction, this$0) {
        this.tgr_1 = $this_primaryResponseAction;
        this.ugr_1 = this$0;
      }
      yah($this$FormAction, $completion) {
        var tmp = SecondaryButtonSemantic_getInstance();
        confirmationDialog(this.tgr_1, 'Propose Alternative?', '', 'Propose', VOID, tmp, VOID, VOID, VOID, VOID, IncidentReportForm$primaryResponseAction$lambda$slambda$slambda_0(this.ugr_1, this.tgr_1));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$primaryResponseAction$lambda$slambdaClass_2 = $;
  }
  return IncidentReportForm$primaryResponseAction$lambda$slambdaClass_2;
}
function IncidentReportForm$primaryResponseAction$lambda$slambda_6($this_primaryResponseAction, this$0) {
  var i = new (IncidentReportForm$primaryResponseAction$lambda$slambda_5())($this_primaryResponseAction, this$0);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$primaryResponseAction$lambda$slambdaClass_3;
function IncidentReportForm$primaryResponseAction$lambda$slambda_7() {
  if (IncidentReportForm$primaryResponseAction$lambda$slambdaClass_3 === VOID) {
    class $ {
      constructor($this_primaryResponseAction, this$0) {
        this.vgr_1 = $this_primaryResponseAction;
        this.wgr_1 = this$0;
      }
      yah($this$FormAction, $completion) {
        var tmp = IssueButton_getInstance();
        confirmationDialog(this.vgr_1, 'Resubmit Issue?', 'This keeps the Issue active and sends your updated concerns to the contractor.', 'Resubmit Issue', VOID, tmp, VOID, VOID, VOID, VOID, IncidentReportForm$primaryResponseAction$lambda$slambda$slambda_2(this.wgr_1, this.vgr_1));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$primaryResponseAction$lambda$slambdaClass_3 = $;
  }
  return IncidentReportForm$primaryResponseAction$lambda$slambdaClass_3;
}
function IncidentReportForm$primaryResponseAction$lambda$slambda_8($this_primaryResponseAction, this$0) {
  var i = new (IncidentReportForm$primaryResponseAction$lambda$slambda_7())($this_primaryResponseAction, this$0);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$primaryResponseAction$lambda$slambdaClass_4;
function IncidentReportForm$primaryResponseAction$lambda$slambda_9() {
  if (IncidentReportForm$primaryResponseAction$lambda$slambdaClass_4 === VOID) {
    class $ {
      constructor($this_remember, $actionName, this$0, $this_primaryResponseAction) {
        this.xgr_1 = $this_remember;
        this.ygr_1 = $actionName;
        this.zgr_1 = this$0;
        this.ags_1 = $this_primaryResponseAction;
      }
      yah($this$FormAction, $completion) {
        var tmp0 = this.xgr_1;
        // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
        var a = this.ygr_1(tmp0);
        var tmp = get_dialogStack();
        var tmp_0 = a + '?';
        var tmp_1 = IncidentReportForm$primaryResponseAction$lambda$slambda$lambda;
        tmp.zgd(new (GenericConfirmationDialog())(tmp_0, '', VOID, 'Submit', VOID, VOID, VOID, VOID, tmp_1, VOID, IncidentReportForm$primaryResponseAction$lambda$slambda$slambda_4(this.zgr_1, this.ags_1)));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$primaryResponseAction$lambda$slambdaClass_4 = $;
  }
  return IncidentReportForm$primaryResponseAction$lambda$slambdaClass_4;
}
function IncidentReportForm$primaryResponseAction$lambda$slambda_10($this_remember, $actionName, this$0, $this_primaryResponseAction) {
  var i = new (IncidentReportForm$primaryResponseAction$lambda$slambda_9())($this_remember, $actionName, this$0, $this_primaryResponseAction);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$lockProjectAction$slambdaClass;
function IncidentReportForm$lockProjectAction$slambda() {
  if (IncidentReportForm$lockProjectAction$slambdaClass === VOID) {
    class $ {
      constructor($this_lockProjectAction, this$0) {
        this.bgs_1 = $this_lockProjectAction;
        this.cgs_1 = this$0;
      }
      yah($this$ButtonAction, $completion) {
        confirmLockProject(this.bgs_1, IncidentReportForm$lockProjectAction$slambda$slambda_0(this.cgs_1, this.bgs_1));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$lockProjectAction$slambdaClass = $;
  }
  return IncidentReportForm$lockProjectAction$slambdaClass;
}
function IncidentReportForm$lockProjectAction$slambda_0($this_lockProjectAction, this$0) {
  var i = new (IncidentReportForm$lockProjectAction$slambda())($this_lockProjectAction, this$0);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$actionBar$lambda$slambdaClass;
function IncidentReportForm$actionBar$lambda$slambda() {
  if (IncidentReportForm$actionBar$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_actionBar) {
        this.dgs_1 = this$0;
        this.egs_1 = $this_actionBar;
      }
      yah($this$FormAction, $completion) {
        sendResponseConfirmation(this.dgs_1, this.egs_1, 'Report Incident?', 'This documents the incident and notifies the contractor. No response is required from the contractor. If this concern develops into an issue later, you can file a new incident report and raise it to an Issue at that time.', 'Report Incident', ReportIncidentButton_getInstance());
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$actionBar$lambda$slambdaClass = $;
  }
  return IncidentReportForm$actionBar$lambda$slambdaClass;
}
function IncidentReportForm$actionBar$lambda$slambda_0(this$0, $this_actionBar) {
  var i = new (IncidentReportForm$actionBar$lambda$slambda())(this$0, $this_actionBar);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$actionBar$lambda$slambdaClass_0;
function IncidentReportForm$actionBar$lambda$slambda_1() {
  if (IncidentReportForm$actionBar$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.fgs_1 = this$0;
      }
      yah($this$FormAction, $completion) {
        var tmp = get_dialogStack();
        tmp.zgd(IncidentRequestSignOffDialog(this.fgs_1.dgn_1, this.fgs_1.mgn_1, ($this$IncidentRequestSignOffDialog, it) => {
          var tmp;
          if (it) {
            closeForm(this.fgs_1, $this$IncidentRequestSignOffDialog);
            tmp = Unit_instance;
          } else {
            get_dialogStack().pgd();
            tmp = Unit_instance;
          }
          return Unit_instance;
        }));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$actionBar$lambda$slambdaClass_0 = $;
  }
  return IncidentReportForm$actionBar$lambda$slambdaClass_0;
}
function IncidentReportForm$actionBar$lambda$slambda_2(this$0) {
  var i = new (IncidentReportForm$actionBar$lambda$slambda_1())(this$0);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$actionBar$lambda$slambdaClass_1;
function IncidentReportForm$actionBar$lambda$slambda_3() {
  if (IncidentReportForm$actionBar$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $pRes) {
        this.ggs_1 = this$0;
        this.hgs_1 = $pRes;
      }
      yah($this$FormAction, $completion) {
        get_dialogStack().zgd(new (ResponseForm())(this.ggs_1, this.hgs_1));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$actionBar$lambda$slambdaClass_1 = $;
  }
  return IncidentReportForm$actionBar$lambda$slambdaClass_1;
}
function IncidentReportForm$actionBar$lambda$slambda_4(this$0, $pRes) {
  var i = new (IncidentReportForm$actionBar$lambda$slambda_3())(this$0, $pRes);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$actionBar$slambdaClass;
function IncidentReportForm$actionBar$slambda() {
  if (IncidentReportForm$actionBar$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_actionBar) {
        this.igs_1 = this$0;
        this.jgs_1 = $this_actionBar;
      }
      yah($this$FormAction, $completion) {
        var action = 'Propose/Deny';
        var tmp = get_dialogStack();
        // Inline function 'kotlin.also' call
        var this_0 = new (TextInputDialog())(action, 'Do you have a resolution in mind to end the dispute? If so, you can propose a resolution to the contractor. Once sent, the contractor will review it and send back a formal proposal for you to accept or deny.', action, VOID, this.igs_1.tgn_1, VOID, IncidentReportForm$actionBar$slambda$slambda_0(this.igs_1, this.jgs_1));
        this_0.sgs_1.oam(this.igs_1.ugn_1.f2());
        tmp.zgd(this_0);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$actionBar$slambdaClass = $;
  }
  return IncidentReportForm$actionBar$slambdaClass;
}
function IncidentReportForm$actionBar$slambda_0(this$0, $this_actionBar) {
  var i = new (IncidentReportForm$actionBar$slambda())(this$0, $this_actionBar);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
var IncidentReportForm$actionBar$slambdaClass_0;
function IncidentReportForm$actionBar$slambda_1() {
  if (IncidentReportForm$actionBar$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $lockProject) {
        this.tgs_1 = this$0;
        this.ugs_1 = $lockProject;
      }
      yah($this$FormAction, $completion) {
        get_dialogStack().zgd(new (ResponseForm())(this.tgs_1, new (Constant())(_Constant___init__impl__v45mub(this.ugs_1))));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    IncidentReportForm$actionBar$slambdaClass_0 = $;
  }
  return IncidentReportForm$actionBar$slambdaClass_0;
}
function IncidentReportForm$actionBar$slambda_2(this$0, $lockProject) {
  var i = new (IncidentReportForm$actionBar$slambda_1())(this$0, $lockProject);
  var l = ($this$FormAction, $completion) => i.yah($this$FormAction, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
var IncidentReportForm$attachmentButton$slambdaClass;
function IncidentReportForm$attachmentButton$slambda() {
  if (IncidentReportForm$attachmentButton$slambdaClass === VOID) {
    class $ {
      constructor($$this$button, this$0) {
        this.vgq_1 = $$this$button;
        this.wgq_1 = this$0;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$attachmentButton$slambdaClass = $;
  }
  return IncidentReportForm$attachmentButton$slambdaClass;
}
function IncidentReportForm$attachmentButton$slambda_0($$this$button, this$0) {
  var i = new (IncidentReportForm$attachmentButton$slambda())($$this$button, this$0);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var IncidentReportForm$actionBar$goBackButton$slambdaClass;
function IncidentReportForm$actionBar$goBackButton$slambda() {
  if (IncidentReportForm$actionBar$goBackButton$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.vgs_1 = this$0;
        this.wgs_1 = $$this$button;
      }
      uao($completion) {
        closeForm(this.vgs_1, this.wgs_1);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    IncidentReportForm$actionBar$goBackButton$slambdaClass = $;
  }
  return IncidentReportForm$actionBar$goBackButton$slambdaClass;
}
function IncidentReportForm$actionBar$goBackButton$slambda_0(this$0, $$this$button) {
  var i = new (IncidentReportForm$actionBar$goBackButton$slambda())(this$0, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var IncidentReportFormClass;
function IncidentReportForm() {
  if (IncidentReportFormClass === VOID) {
    class $ {
      constructor(project, incident, messages, client, contractor, isClient, role, maxCredit) {
        this.cgn_1 = project;
        this.dgn_1 = incident;
        this.egn_1 = messages;
        this.fgn_1 = client;
        this.ggn_1 = contractor;
        this.hgn_1 = isClient;
        this.ign_1 = role;
        this.jgn_1 = maxCredit;
        var tmp = this;
        var tmp_0;
        if (this.dgn_1 == null) {
          tmp_0 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        } else {
          tmp_0 = remember(VOID, VOID, VOID, ($this$remember) => {
            var tmp = $this$remember.daj(get_session()).kfw_1;
            var tmp0_limit = 2147483647;
            // Inline function 'com.lightningkite.lightningdb.condition' call
            // Inline function 'com.lightningkite.lightningdb.path' call
            // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
            var tmp_0 = serializerOrContextual(createKType(getKClass(IncidentMessageComment()), arrayOf([]), false));
            var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it = new (DataClassPathSelf())(tmp$ret$0);
            var tmp1_condition = eq(get_incident_1(it), this.dgn_1.b63_1);
            // Inline function 'com.lightningkite.lightningdb.sort' call
            // Inline function 'kotlin.apply' call
            var this_0 = new (SortBuilder())();
            // Inline function 'com.lightningkite.lightningdb.path' call
            // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
            var tmp_1 = serializerOrContextual(createKType(getKClass(IncidentMessageComment()), arrayOf([]), false));
            var tmp$ret$5 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
            var it_0 = new (DataClassPathSelf())(tmp$ret$5);
            this_0.k4a(get_created(it_0));
            var tmp2_orderBy = this_0.m1r();
            return $this$remember.daj(tmp.heo(new (Query())(tmp1_condition, tmp2_orderBy, VOID, tmp0_limit)));
          });
        }
        tmp.kgn_1 = tmp_0;
        this.lgn_1 = lastOrNull(this.egn_1);
        this.mgn_1 = new (IncidentFlowPermissions())(this.cgn_1, this.dgn_1, this.egn_1, this.hgn_1, this.ign_1);
        this.ngn_1 = Signal().hak(false);
        this.ogn_1 = new (IssueNode())(null);
        var tmp_1 = this;
        var tmp_2;
        if (this.hgn_1) {
          tmp_2 = this.dgn_1 == null ? new (FileIncident())(ClientConcern_Other_getInstance()) : new (ClientResponse())();
        } else if (!this.hgn_1 && this.mgn_1.s9d_1) {
          // Inline function 'kotlin.collections.firstNotNullOf' call
          var tmp0 = asReversed(this.egn_1);
          var tmp$ret$12;
          $l$block: {
            // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              var tmp_3 = element.h94();
              var result = tmp_3 instanceof Remedy() ? tmp_3 : null;
              if (!(result == null)) {
                tmp$ret$12 = result;
                break $l$block;
              }
            }
            tmp$ret$12 = null;
          }
          var tmp0_elvis_lhs = tmp$ret$12;
          var tmp_4;
          if (tmp0_elvis_lhs == null) {
            throw NoSuchElementException().o('No element of the collection was transformed to a non-null value.');
          } else {
            tmp_4 = tmp0_elvis_lhs;
          }
          var tmp$ret$13 = tmp_4;
          tmp_2 = new (RemedyHandled())(tmp$ret$13);
        } else {
          tmp_2 = null;
        }
        tmp_1.pgn_1 = validated(Signal().hak(tmp_2), this.ogn_1);
        var tmp_5 = this;
        var tmp_6 = Signal().hak(null);
        tmp_5.qgn_1 = validated_0(interceptWrite(tmp_6, IncidentReportForm$clientConcern$slambda_0(this)), this.pgn_1.xat());
        this.rgn_1 = Signal().hak(false);
        this.sgn_1 = Signal().hak(false);
        this.tgn_1 = 35;
        var tmp_7 = this;
        var tmp_8 = validated(Signal().hak(''), this.ogn_1);
        var tmp_9 = 'Message must be longer than ' + this.tgn_1 + ' characters';
        tmp_7.ugn_1 = assert(tmp_8, tmp_9, VOID, VOID, (it) => it.length > this.tgn_1);
        this.vgn_1 = ReactiveMutableList().vam();
        this.wgn_1 = Signal().hak(null);
        this.xgn_1 = this.ogn_1.vat();
        validateReactive(this.xgn_1, ($this$validateReactive) => {
          var tmp0_subject = $this$validateReactive.daj(this.pgn_1);
          var tmp;
          if (tmp0_subject instanceof Credit_0()) {
            var tmp_0 = $this$validateReactive.daj(this.wgn_1);
            var credit = tmp_0 == null ? null : tmp_0.y5r_1;
            var tmp_1;
            var tmp_2 = credit;
            if ((tmp_2 == null ? null : new (MonetaryValue())(tmp_2)) == null) {
              tmp_1 = 'Credit cannot be blank';
            } else {
              if (MonetaryValue__compareTo_impl_w7ul1r(credit, Companion_instance.r91(0n)) <= 0) {
                tmp_1 = 'Credit must be greater than 0';
              } else {
                if (MonetaryValue__compareTo_impl_w7ul1r(this.jgn_1, credit) < 0) {
                  tmp_1 = 'Credit cannot exceed ' + MonetaryValue__toString_impl_xslc77(this.jgn_1);
                } else {
                  tmp_1 = null;
                }
              }
            }
            tmp = tmp_1;
          } else {
            if (tmp0_subject instanceof Remedy()) {
              var tmp_3 = $this$validateReactive.daj(this.wgn_1);
              var tmp1_elvis_lhs = tmp_3 == null ? null : tmp_3.y5r_1;
              var tmp_4;
              var tmp_5 = tmp1_elvis_lhs;
              if ((tmp_5 == null ? null : new (MonetaryValue())(tmp_5)) == null) {
                return null;
              } else {
                tmp_4 = tmp1_elvis_lhs;
              }
              var credit_0 = tmp_4;
              tmp = MonetaryValue__compareTo_impl_w7ul1r(credit_0, Companion_instance.r91(0n)) <= 0 ? 'Credit must be greater than 0' : MonetaryValue__compareTo_impl_w7ul1r(this.jgn_1, credit_0) < 0 ? 'Credit cannot exceed ' + MonetaryValue__toString_impl_xslc77(this.jgn_1) : null;
            } else {
              tmp = null;
            }
          }
          return tmp;
        });
        this.ygn_1 = (this.dgn_1 == null && this.hgn_1);
        var tmp_10 = this;
        tmp_10.zgn_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.sgn_1) ? EscalationLevel_Disputed_getInstance() : this.mgn_1.l8w());
        this.ago_1 = Signal().hak(false);
        var tmp_11 = this;
        tmp_11.bgo_1 = remember(VOID, VOID, VOID, ($this$remember) => banners(($this$banners) => {
          var tmp;
          var tmp0_safe_receiver = this.dgn_1;
          if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.i63_1, IncidentState_Filed_getInstance())) {
            var tmp_0;
            if (this.hgn_1) {
              $this$banners.zfz('H-IRF-Filed-info', 'Incident reported for documentation. No contractor response required. If this concern develops into an issue, file a new incident report and raise it to an Issue.');
              tmp_0 = Unit_instance;
            } else {
              $this$banners.zfz('C-IRF-Filed-info', 'Client reported this incident for documentation. No response required. Review the details for your records. Take action as needed.');
              tmp_0 = Unit_instance;
            }
            tmp = tmp_0;
          } else {
            var tmp8_safe_receiver = this.dgn_1;
            if (equals(tmp8_safe_receiver == null ? null : tmp8_safe_receiver.i63_1, IncidentState_Resolved_getInstance())) {
              var tmp0 = asReversed(this.mgn_1.s8x());
              var tmp$ret$15;
              $l$block_0: {
                // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
                var _iterator__ex2g4s = tmp0.m1();
                while (_iterator__ex2g4s.n1()) {
                  var element = _iterator__ex2g4s.o1();
                  var tmp_1 = element.h94();
                  var result = tmp_1 instanceof Accept() ? tmp_1 : null;
                  if (!(result == null)) {
                    tmp$ret$15 = result;
                    break $l$block_0;
                  }
                }
                tmp$ret$15 = null;
              }
              var accept = tmp$ret$15;
              var tmp2_safe_receiver = accept == null ? null : accept.q9e_1;
              var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.c9f(this.mgn_1.p9d_1);
              var tmp_2 = tmp3_elvis_lhs == null ? '...' : tmp3_elvis_lhs;
              var tmp5_safe_receiver = accept == null ? null : accept.r9e_1;
              var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.o54_1;
              var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : format(tmp6_safe_receiver, Formats_getInstance().i8z_1);
              $this$banners.zfz('IRF-Resolved', 'Incident resolved. ' + tmp_2 + ' was accepted on ' + (tmp7_elvis_lhs == null ? '...' : tmp7_elvis_lhs) + '.');
              tmp = Unit_instance;
            } else {
              var tmp16_safe_receiver = this.dgn_1;
              if (equals(tmp16_safe_receiver == null ? null : tmp16_safe_receiver.i63_1, IncidentState_Settled_getInstance())) {
                var tmp0_0 = asReversed(this.mgn_1.s8x());
                var tmp$ret$17;
                $l$block_1: {
                  // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
                  var _iterator__ex2g4s_0 = tmp0_0.m1();
                  while (_iterator__ex2g4s_0.n1()) {
                    var element_0 = _iterator__ex2g4s_0.o1();
                    var tmp_3 = element_0.h94();
                    var result_0 = tmp_3 instanceof Accept() ? tmp_3 : null;
                    if (!(result_0 == null)) {
                      tmp$ret$17 = result_0;
                      break $l$block_1;
                    }
                  }
                  tmp$ret$17 = null;
                }
                var accept_0 = tmp$ret$17;
                var tmp10_safe_receiver = accept_0 == null ? null : accept_0.q9e_1;
                var tmp11_elvis_lhs = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.c9f(this.mgn_1.p9d_1);
                var tmp_4 = tmp11_elvis_lhs == null ? '...' : tmp11_elvis_lhs;
                var tmp13_safe_receiver = accept_0 == null ? null : accept_0.r9e_1;
                var tmp14_safe_receiver = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.o54_1;
                var tmp15_elvis_lhs = tmp14_safe_receiver == null ? null : format(tmp14_safe_receiver, Formats_getInstance().i8z_1);
                $this$banners.zfz('IRF-Resolved', 'Dispute settled. ' + tmp_4 + ' was accepted on ' + (tmp15_elvis_lhs == null ? '...' : tmp15_elvis_lhs) + '.');
                tmp = Unit_instance;
              } else {
                var tmp17_safe_receiver = this.lgn_1;
                var tmp_5 = tmp17_safe_receiver == null ? null : tmp17_safe_receiver.h94();
                if (tmp_5 instanceof MoreInfo()) {
                  var tmp_6;
                  if (this.hgn_1) {
                    $this$banners.zfz('H-IRF-MoreInfo-info', 'Contractor requested more information. Review their question and respond with the requested details or attachments.');
                    tmp_6 = Unit_instance;
                  }
                  tmp = tmp_6;
                } else {
                  var tmp20_safe_receiver = this.lgn_1;
                  var tmp_7 = tmp20_safe_receiver == null ? null : tmp20_safe_receiver.h94();
                  if (tmp_7 instanceof Handled()) {
                    var tmp_8;
                    if (this.hgn_1) {
                      var tmp18_safe_receiver = this.mgn_1.p9e();
                      var tmp19_subject = tmp18_safe_receiver == null ? null : tmp18_safe_receiver.h94();
                      var tmp_9;
                      var tmp_10;
                      if (tmp19_subject instanceof Remedy()) {
                        tmp_10 = true;
                      } else {
                        tmp_10 = tmp19_subject instanceof Credit_0();
                      }
                      if (tmp_10) {
                        tmp_9 = 'Propose';
                      } else {
                        tmp_9 = 'Resubmit Issue';
                      }
                      var denial = tmp_9;
                      $this$banners.zfz('H-IRF-Handled-info', 'Contractor reports your concerns have been addressed. "Accept Handled" to resolve incident. ' + denial + ' if concerns remain or to escalate.');
                      tmp_8 = Unit_instance;
                    }
                    tmp = tmp_8;
                  } else {
                    var tmp21_safe_receiver = this.lgn_1;
                    var tmp_11 = tmp21_safe_receiver == null ? null : tmp21_safe_receiver.h94();
                    if (tmp_11 instanceof RequestSiteVisit()) {
                      var tmp_12;
                      if (this.hgn_1) {
                        $this$banners.zfz('H-IRF-RequestJobVisit-info', 'Contractor wants to meet on-site to address concerns. Confirm the visit to pause the timer and schedule a meeting.');
                        tmp_12 = Unit_instance;
                      }
                      tmp = tmp_12;
                    } else {
                      var tmp_13;
                      if (!this.mgn_1.u9d_1) {
                        var tmp_14 = setOf_0([IncidentState_IssueFiled_getInstance(), IncidentState_Issue_getInstance()]);
                        var tmp22_safe_receiver = this.dgn_1;
                        tmp_13 = contains(tmp_14, tmp22_safe_receiver == null ? null : tmp22_safe_receiver.i63_1);
                      } else {
                        tmp_13 = false;
                      }
                      if (tmp_13) {
                        var tmp_15;
                        if (this.hgn_1) {
                          $this$banners.zfz('H-IRF-IssueRaised-info', "You've raised a formal Issue. The contractor will respond with options to address your concerns.");
                          tmp_15 = Unit_instance;
                        } else {
                          $this$banners.zfz('C-IRF-Issue-info', "Client has raised a formal Issue. Review their concerns below and respond. Your options: explain what's been handled, request more information, submit a remedy plan, offer a credit, or request a site visit.");
                          tmp_15 = Unit_instance;
                        }
                        tmp = tmp_15;
                      } else {
                        var tmp_16;
                        if (this.mgn_1.u9d_1) {
                          var tmp23_safe_receiver = this.dgn_1;
                          tmp_16 = equals(tmp23_safe_receiver == null ? null : tmp23_safe_receiver.i63_1, IncidentState_Disputed_getInstance());
                        } else {
                          tmp_16 = false;
                        }
                        if (tmp_16) {
                          var tmp_17;
                          if (!this.hgn_1) {
                            $this$banners.zfz('C-IRF-Disputed-info', 'Client has filed a formal Dispute. Review their concerns and propose how to settle: offer credit, submit a remedy plan, appeal the dispute, or request a site visit.');
                            tmp_17 = Unit_instance;
                          }
                          tmp = tmp_17;
                        } else {
                          if (this.mgn_1.t9d_1 && equals(this.mgn_1.l8w(), EscalationLevel_Issue_getInstance())) {
                            var tmp_18;
                            if (this.hgn_1) {
                              $this$banners.zfz('H-IRF-IssueSubmitted-info', "You've raised a formal Issue. The contractor will respond with options to address your concerns.");
                              tmp_18 = Unit_instance;
                            } else {
                              $this$banners.zfz('C-IRF-IssueSubmitted-info', "Client has raised a formal Issue. Review their concerns below and respond. Your options: explain what's been handled, request more information, submit a remedy plan, offer a credit, request a site visit, or explain why you're not responsible.");
                              tmp_18 = Unit_instance;
                            }
                            tmp = tmp_18;
                          } else {
                            if (this.mgn_1.t9d_1 && equals(this.mgn_1.l8w(), EscalationLevel_Disputed_getInstance())) {
                              var tmp_19 = $this$remember.daj(get_session()).ffw_1;
                              // Inline function 'com.lightningkite.lightningdb.Query' call
                              // Inline function 'kotlin.collections.listOf' call
                              var orderBy = emptyList();
                              // Inline function 'com.lightningkite.lightningdb.path' call
                              // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
                              var tmp_20 = serializerOrContextual(createKType(getKClass(ProjectTimer()), arrayOf([]), false));
                              var tmp$ret$19 = isInterface(tmp_20, KSerializer()) ? tmp_20 : THROW_CCE();
                              var it = new (DataClassPathSelf())(tmp$ret$19);
                              var tmp_21 = running(it);
                              var tmp_22 = get_incident_2(it);
                              var tmp0_safe_receiver_0 = this.dgn_1;
                              var tmp$ret$21 = and(and(tmp_21, eq(tmp_22, tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.b63_1)), eq(get_action(it), TimerAction_AllowLockProject_getInstance()));
                              var tmp$ret$22 = new (Query())(tmp$ret$21, orderBy, 0, 1);
                              var timer = firstOrNull($this$remember.daj(tmp_19.heo(tmp$ret$22)));
                              var tmp25_safe_receiver = timer == null ? null : timer.v7t_1;
                              var tmp26_elvis_lhs = tmp25_safe_receiver == null ? null : format(tmp25_safe_receiver, Formats_getInstance().h8z_1);
                              var lock = tmp26_elvis_lhs == null ? '...' : tmp26_elvis_lhs;
                              var tmp_23;
                              if (this.hgn_1) {
                                $this$banners.zfz('H-IRF-DisputeFiled-info', "You've filed a formal Dispute. The contractor will respond with options to address your concerns. If not settled within 14 days, either party can lock the project.");
                                $this$banners.ag0('H-IRF-DisputeFiled-warn', 'Dispute filed. If not settled within 14 days, lock becomes available on ' + lock + '.');
                                tmp_23 = Unit_instance;
                              } else {
                                $this$banners.zfz('C-IRF-DisputeFiled-info', "Client has raised a formal Issue. Review their concerns below and respond. Your options: explain what's been handled, request more information, submit a remedy plan, offer a credit, request a site visit, or explain why you're not responsible.");
                                tmp_23 = Unit_instance;
                              }
                              tmp = tmp_23;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          return Unit_instance;
        }));
        var tmp_12 = this;
        tmp_12.cgo_1 = remember(VOID, VOID, VOID, ($this$remember) => banners(($this$banners) => {
          var disputed = this.mgn_1.t8w();
          var tmp;
          if (!this.hgn_1) {
            var tmp0_subject = $this$remember.daj(this.pgn_1);
            var tmp_0;
            if (equals(tmp0_subject, MoreInfo_instance)) {
              $this$banners.ag0('C-IRF-RF-MoreInfo-warn', "Use when you need clarification on the client's concern. Request pictures or detailed explanations. Client can provide info or escalate to a dispute.");
              tmp_0 = Unit_instance;
            } else {
              if (tmp0_subject instanceof Handled()) {
                $this$banners.ag0('C-IRF-RF-Handled-warn', "Use this when you've already addressed the concern through quick fixes, cleanup, or clarification. Explain what you did or clarify the existing concern. Optional credit available. Client can accept, continue discussion by resubmitting issue, or escalate to a dispute. ");
                tmp_0 = Unit_instance;
              } else {
                if (tmp0_subject instanceof RequestSiteVisit()) {
                  var tmp_1;
                  if (disputed) {
                    $this$banners.bg0('C-IRF-RF-RequestSiteVisit-dispute', 'Request an on-site meeting to discuss the dispute in person. Include suggested meeting times. Submit your proposed settlement after the meeting takes place.');
                    tmp_1 = Unit_instance;
                  } else {
                    $this$banners.ag0('C-IRF-RF-RequestSiteVisit', 'Request an on-site meeting to discuss the incident in person. Include suggested meeting times in your response. Submit your proposed solution after the meeting based on the discussion.');
                    tmp_1 = Unit_instance;
                  }
                  tmp_0 = tmp_1;
                } else {
                  if (tmp0_subject instanceof Credit_0()) {
                    var tmp_2;
                    if (disputed) {
                      $this$banners.bg0('C-IRF-RF-Credit-dispute', "Offer a monetary credit to settle the dispute. Specify the credit amount and explain how this addresses the client's concerns. Client can accept the credit or continue dispute discussion.");
                      tmp_2 = Unit_instance;
                    } else {
                      $this$banners.ag0('C-IRF-RF-Credit', "Offer a monetary credit as a solution. Specify the credit amount and explain how this addresses the client's concerns. Client can accept the credit, propose an alternative, or escalate to a dispute.");
                      tmp_2 = Unit_instance;
                    }
                    tmp_0 = tmp_2;
                  } else {
                    if (tmp0_subject instanceof Remedy()) {
                      var tmp_3;
                      if (disputed) {
                        $this$banners.bg0('C-IRF-RF-Remedy-dispute', 'Propose a detailed plan to settle the dispute including specific actions to be taken, timeline, and approach. Credit can also be included in your plan. Client can accept your plan, propose modifications, or continue dispute discussion.');
                        tmp_3 = Unit_instance;
                      } else {
                        $this$banners.ag0('C-IRF-RF-Remedy', 'Propose a detailed plan to address the incident including specific actions to be taken, timeline, and approach. Credit can also be included in your plan. Client can accept your last submission, accept your remedy plan, or escalate to a dispute.');
                        tmp_3 = Unit_instance;
                      }
                      tmp_0 = tmp_3;
                    } else {
                      if (tmp0_subject instanceof NotResponsible()) {
                        var tmp_4;
                        if (disputed) {
                          $this$banners.bg0('C-IRF-RF-NotResponsible-dispute', 'Formally state you are not responsible for this incident. Explain why this is not your fault or responsibility. Client can accept your position or continue dispute discussion. If dispute remains unresolved after 14 days, either party can lock the project.');
                          tmp_4 = Unit_instance;
                        } else {
                          $this$banners.ag0('C-IRF-RF-NotResponsible', 'Use this when you are not responsible for the incident. Explain why this is not your fault or responsibility. Client can accept your position or escalate to a dispute.');
                          tmp_4 = Unit_instance;
                        }
                        tmp_0 = tmp_4;
                      } else {
                        if (tmp0_subject instanceof Appeal()) {
                          var tmp_5;
                          if (disputed) {
                            $this$banners.bg0('C-IRF-RF-Appeal-dispute', 'Challenge the dispute, explain your reasoning, this is your formal position. Client can accept your appeal or continue discussion.');
                            tmp_5 = Unit_instance;
                          } else {
                            $this$banners.ag0('C-IRF-RF-Appeal', 'Challenge the issue, explain your reasoning, this is your formal position. Client can accept your appeal or file a dispute.');
                            tmp_5 = Unit_instance;
                          }
                          tmp_0 = tmp_5;
                        } else {
                          tmp_0 = Unit_instance;
                        }
                      }
                    }
                  }
                }
              }
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        }));
      }
      fgq($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_sendResponse__y29akh.bind(VOID, this), $completion);
      }
      egh(_this__u8e3s4) {
        return this.hgn_1 ? new (ClientProject())(this.cgn_1.v7a_1) : new (ContractorProject())(this.cgn_1.v7a_1);
      }
      xgs(_this__u8e3s4) {
        return _this__u8e3s4.lbb(get_scrolling(_this__u8e3s4), page(this, _this__u8e3s4));
      }
      ygs(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        var tmp0_vertical = get_px(0);
        var tmp1_horizontal = get_AppDimensions().yg1_1;
        view.jba(Edges().ed0(tmp1_horizontal, tmp0_vertical));
        view.vbo(IncidentReportForm$renderAsDialog$slambda_0(this, view));
        var tmp_0 = get_atTopCenter(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.jba(Edges().cd0(get_px(0)).id0(VOID, get_rem(3), VOID, get_rem(5)));
        view_0.eb9(true);
        view_0.lbb(view_0.kbb(view_0.kbb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().gg2_1), get_atTopCenter(view_0)), view_0.jbb(DialogSemantic_getInstance())), page(this, view_0));
        view.hbb(p_0, view_0);
        view.lbb(tmp_0, view_0);
        _this__u8e3s4.hbb(p, view);
        return _this__u8e3s4.lbb(tmp, view);
      }
    }
    protoOf($).wd6 = render;
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'IncidentReportForm', VOID, VOID, [DialogOrPage(), HasFallback()], [0]);
    IncidentReportFormClass = $;
  }
  return IncidentReportFormClass;
}
//region block: init
Companion_instance_1 = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance_1 as Companion_instance2o1tmep3w0ant,
};
//endregion

//# sourceMappingURL=IncidentReportForm.mjs.map
